var _style, _g, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _g2, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _g3, _g4, _g5, _polygon14, _polygon15, _polygon16, _polygon17, _g6, _g7, _g8, _polygon18, _polygon19, _polygon20, _polygon21, _g9, _g10, _g11, _polygon22, _polygon23, _polygon24, _polygon25, _g12, _g13, _g14, _polygon26, _polygon27, _polygon28, _polygon29, _g15, _g16, _g17, _polygon30, _polygon31, _polygon32, _polygon33, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _polygon41, _g33, _g34, _g35, _g36, _g37, _g38, _polygon42, _polygon43, _polygon44, _path, _polygon45, _g39, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCavesvin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.6 198",
    style: {
      enableBackground: "new 0 0 230.6 198"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#757B7E;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:#929799;}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:#2E373B;}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:#9D7657;}\n\t.st12{fill:#E9AE7E;}\n\t.st13{fill:#F9C8A3;}\n\t.st14{fill:none;stroke:#F4E3D4;stroke-width:0.6445;stroke-linecap:round;stroke-linejoin:round;}\n\t.st15{opacity:0.8;fill:#4D5558;}\n\t.st16{fill:#9B121A;}\n\t.st17{fill:#BB0128;}\n\t.st18{opacity:0.3;fill:#BABDBE;}\n\t.st19{opacity:0.3;fill:#B0B3B4;}\n\t.st20{fill:#FFFFFF;}\n\t.st21{fill:url(#SVGID_9_);}\n\t.st22{fill:url(#SVGID_10_);}\n\t.st23{fill:url(#SVGID_11_);}\n\t.st24{fill:url(#SVGID_12_);}\n\t.st25{fill:url(#SVGID_13_);}\n\t.st26{fill:url(#SVGID_14_);}\n\t.st27{fill:url(#SVGID_15_);}\n\t.st28{fill:url(#SVGID_16_);}\n\t.st29{fill:url(#SVGID_17_);}\n\t.st30{fill:url(#SVGID_18_);}\n\t.st31{fill:#B3A84E;}\n\t.st32{opacity:0.8;fill:#BEB568;}\n\t.st33{opacity:0.3;fill:#E6E2C4;}\n\t.st34{opacity:0.3;fill:#E2DEBC;}\n\t.st35{fill:url(#SVGID_19_);}\n\t.st36{fill:url(#SVGID_20_);}\n\t.st37{fill:url(#SVGID_21_);}\n\t.st38{fill:url(#SVGID_22_);}\n\t.st39{fill:#A3A7A9;}\n\t.st40{fill:url(#SVGID_23_);}\n\t.st41{fill:#666D70;}\n\t.st42{fill:#B1DFF5;}\n\t.st43{fill:#CFEBF8;}\n\t.st44{fill:url(#SVGID_24_);}\n\t.st45{fill:url(#SVGID_25_);}\n\t.st46{fill:url(#SVGID_26_);}\n\t.st47{fill:#ADB1B2;}\n\t.st48{fill:url(#SVGID_27_);}\n\t.st49{fill:url(#SVGID_28_);}\n\t.st50{fill:url(#SVGID_29_);}\n\t.st51{fill:none;stroke:#C0BBBB;stroke-width:0.6445;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REPERES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.826,
    y1: 182.4135,
    x2: 96.2739,
    y2: 152.3295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#454D50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    style: {
      stopColor: "#495155"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    style: {
      stopColor: "#565E61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7174"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.81,158.38 108.13,130.92 128.99,143.84 85.67,171.3  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.81,158.38 65.26,170.47 85.98,183.38 85.67,171.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.9441,
    y1: 200.5382,
    x2: 137.1241,
    y2: 100.379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D4549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    style: {
      stopColor: "#41494D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4161,
    style: {
      stopColor: "#4E5659"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6418,
    style: {
      stopColor: "#646B6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    style: {
      stopColor: "#82888A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#969B9D"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "128.99,143.84 129.02,155.91 85.98,183.38 85.67,171.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.3882,
    y1: 178.0473,
    x2: 96.7154,
    y2: 150.1457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#454D50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    style: {
      stopColor: "#495155"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    style: {
      stopColor: "#565E61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7174"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "64.64,153.61 104.27,128.52 129.95,144.41 90.32,169.51  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.64,153.61 64.81,158.39 90.43,174.28 90.32,169.51  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.0282,
    y1: 189.309,
    x2: 134.2759,
    y2: 108.1124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006709374,
    style: {
      stopColor: "#757B7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3387,
    style: {
      stopColor: "#797F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7068,
    style: {
      stopColor: "#868C8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#969B9D"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "129.95,144.41 129.96,149.18 90.43,174.28 90.32,169.51  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M90.32,169.51c3.16-2.28,6.38-4.46,9.61-6.63c3.24-2.17,6.54-4.25,9.82-6.38c3.33-2.06,6.64-4.15,10-6.17 c3.37-2.02,6.75-4.02,10.2-5.92c-3.24,2.28-6.53,4.46-9.82,6.63c-3.28,2.16-6.6,4.25-9.88,6.38c-3.32,2.05-6.61,4.15-9.93,6.17 C97.01,165.61,93.69,167.61,90.32,169.51z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.8054,
    y1: 32.3116,
    x2: 114.4699,
    y2: 29.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#454D50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    style: {
      stopColor: "#495155"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    style: {
      stopColor: "#565E61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7174"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "99.33,21.94 102.6,20.01 129.75,35.94 126.48,37.87  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "99.33,21.94 101.18,130.45 126.86,146.34 126.48,37.87  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.6747,
    y1: 160.224,
    x2: 183.8458,
    y2: -26.9557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D4549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    style: {
      stopColor: "#41494D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4161,
    style: {
      stopColor: "#4E5659"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6418,
    style: {
      stopColor: "#646B6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    style: {
      stopColor: "#82888A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#969B9D"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "129.75,35.94 129.95,144.41 126.86,146.34 126.48,37.87  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.1307,
    y1: 170.6459,
    x2: 149.9103,
    y2: -32.686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D4549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    style: {
      stopColor: "#41494D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4161,
    style: {
      stopColor: "#4E5659"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6418,
    style: {
      stopColor: "#646B6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    style: {
      stopColor: "#82888A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#969B9D"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "103.34,41.38 104.73,132.63 76.79,150.28 74.03,59  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.7648,
    y1: 171.4169,
    x2: 97.8343,
    y2: 145.9646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2956,
    style: {
      stopColor: "#C3926B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#D19B72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9522,
    style: {
      stopColor: "#E6AA7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAAD7E"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "71.35,151.23 108.15,128 125.37,138.64 88.58,161.87  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "71.35,151.23 71.42,153.33 88.63,163.97 88.58,161.87  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "125.37,138.64 125.38,140.73 88.63,163.97 88.58,161.87  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.58,161.87c5.8-4.36,11.84-8.34,17.95-12.24c6.16-3.86,12.39-7.62,18.85-11 c-5.93,4.36-12.04,8.34-18.18,12.23C101.07,154.72,94.91,158.48,88.58,161.87z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "119.69,144.29 119.67,142.2 102.45,131.56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "114.39,147.62 114.37,145.52 97.15,134.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "109.12,150.94 109.09,148.84 91.87,138.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "103.86,154.26 103.83,152.17 86.61,141.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "98.63,157.59 98.59,155.49 81.36,144.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "93.41,160.91 93.36,158.82 76.14,148.18  "
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.71,135.07c1.03,0.59,2.37,0.75,3.35,0.4c-0.33,0.12-0.64,0.11-0.89-0.03c-0.3-0.2-0.5-0.6-0.52-1.16 c-0.04-1.17,0.7-2.61,1.65-3.23c0.48-0.31,0.93-0.35,1.25-0.15c0.24,0.15,0.41,0.43,0.48,0.81c-0.28-1.35-1.22-2.39-2-2.9 c-0.46-0.29-1.08-0.25-1.77,0.19c-1.31,0.86-2.33,2.85-2.27,4.47C112.01,134.26,112.29,134.8,112.71,135.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M118.04,131.71c0.1,0.3,0.45,0.89,0.89,1.2c-0.2-0.12-0.47-0.1-0.77,0.09c-0.58,0.38-1.04,1.27-1.01,1.98 c0.01,0.34,0.13,0.59,0.31,0.7c-0.09-0.05-0.21-0.1-0.32-0.15c-0.34-0.1-0.75-0.14-1.08-0.08c-0.33,0.12-0.64,0.11-0.89-0.03 c-0.3-0.2-0.5-0.6-0.52-1.16c-0.04-1.17,0.7-2.61,1.65-3.23c0.48-0.31,0.93-0.35,1.25-0.15 C117.8,131.05,117.97,131.33,118.04,131.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115.99,130.58c-0.64-0.4-1.59,0.1-2.12,1.11c-0.53,1.01-0.43,2.14,0.22,2.54 c0.64,0.39,1.59-0.1,2.12-1.1C116.73,132.11,116.64,130.97,115.99,130.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M117.46,135.69l2.15,1.32c-0.19-0.12-0.31-0.36-0.32-0.71c-0.02-0.71,0.44-1.6,1.02-1.97 c0.3-0.2,0.58-0.22,0.77-0.1l-2.15-1.32c-0.2-0.12-0.47-0.1-0.77,0.09c-0.58,0.38-1.04,1.27-1.01,1.98 C117.16,135.33,117.28,135.58,117.46,135.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M121.4,134.95c-0.03-0.72-0.51-0.99-1.09-0.62c-0.58,0.38-1.03,1.27-1.02,1.97 c0.02,0.72,0.51,1,1.09,0.62C120.96,136.54,121.41,135.65,121.4,134.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.74,128.32l10.97,6.75c-0.42-0.27-0.69-0.81-0.71-1.6c-0.06-1.61,0.96-3.61,2.27-4.47 c0.68-0.44,1.3-0.48,1.75-0.2l-10.99-6.76c-0.45-0.28-1.09-0.21-1.76,0.23c-1.31,0.83-2.32,2.84-2.26,4.46 C101.03,127.51,101.31,128.06,101.74,128.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M105.57,123.78c-0.05-1.49-1.08-2.07-2.3-1.28c-1.21,0.77-2.15,2.64-2.11,4.13 c0.07,1.5,1.09,2.09,2.31,1.3C104.68,127.14,105.61,125.28,105.57,123.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M105.37,124.31c-0.04-1.15-0.83-1.59-1.76-0.99c-0.93,0.6-1.65,2.03-1.61,3.16 c0.05,1.16,0.83,1.61,1.76,1C104.7,126.88,105.41,125.45,105.37,124.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M113.08,127c-0.43-0.26-1.04-0.22-1.69,0.21c-0.62,0.4-1.18,1.09-1.58,1.85l-5.09-3.11 c0.4-0.78,0.97-1.46,1.59-1.87c0.65-0.43,1.25-0.48,1.69-0.21L113.08,127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M107.11,138.57c1.02,0.59,2.37,0.75,3.34,0.4c-0.33,0.12-0.64,0.11-0.88-0.03c-0.3-0.2-0.51-0.6-0.52-1.16 c-0.05-1.17,0.69-2.61,1.64-3.23c0.48-0.31,0.93-0.35,1.25-0.15c0.24,0.15,0.41,0.43,0.48,0.81c-0.28-1.35-1.22-2.39-2.01-2.9 c-0.46-0.29-1.08-0.25-1.76,0.19c-1.31,0.86-2.32,2.86-2.25,4.47C106.42,137.76,106.69,138.3,107.11,138.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.42,135.22c0.1,0.3,0.45,0.89,0.89,1.2c-0.2-0.12-0.47-0.1-0.77,0.1c-0.58,0.38-1.03,1.27-1,1.98 c0.01,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.32-0.15c-0.33-0.1-0.75-0.14-1.08-0.08c-0.33,0.12-0.64,0.11-0.88-0.03 c-0.3-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.69-2.61,1.64-3.23c0.48-0.31,0.93-0.35,1.25-0.15 C112.18,134.55,112.35,134.84,112.42,135.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M110.38,134.08c-0.65-0.4-1.59,0.1-2.12,1.11c-0.52,1.01-0.42,2.14,0.22,2.54 c0.64,0.39,1.59-0.1,2.11-1.11C111.12,135.61,111.02,134.47,110.38,134.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M111.86,139.19l2.15,1.32c-0.19-0.12-0.31-0.36-0.32-0.71c-0.02-0.71,0.43-1.6,1.01-1.97 c0.3-0.2,0.57-0.22,0.77-0.1l-2.15-1.32c-0.2-0.12-0.47-0.1-0.77,0.1c-0.58,0.38-1.03,1.27-1,1.98 C111.56,138.83,111.67,139.08,111.86,139.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M115.78,138.45c-0.02-0.72-0.51-0.99-1.09-0.62c-0.58,0.38-1.03,1.27-1.01,1.97 c0.03,0.72,0.51,1,1.09,0.62C115.36,140.04,115.8,139.16,115.78,138.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M96.14,131.82l10.97,6.75c-0.42-0.27-0.7-0.81-0.71-1.6c-0.06-1.61,0.95-3.61,2.25-4.47 c0.68-0.44,1.3-0.48,1.74-0.2l-10.99-6.76c-0.45-0.28-1.09-0.21-1.75,0.23c-1.3,0.83-2.3,2.84-2.24,4.46 C95.44,131.01,95.72,131.56,96.14,131.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M99.95,127.28c-0.06-1.49-1.08-2.07-2.3-1.28c-1.21,0.77-2.14,2.64-2.09,4.13c0.07,1.5,1.09,2.09,2.3,1.3 C99.08,130.64,100,128.78,99.95,127.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M99.76,127.82c-0.04-1.15-0.83-1.59-1.76-0.99c-0.93,0.6-1.64,2.03-1.6,3.17c0.05,1.16,0.84,1.6,1.76,1 C99.09,130.39,99.8,128.95,99.76,127.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M107.45,130.5c-0.43-0.26-1.03-0.22-1.69,0.21c-0.62,0.4-1.17,1.09-1.57,1.85l-5.09-3.11 c0.4-0.78,0.96-1.46,1.58-1.87c0.65-0.43,1.25-0.48,1.69-0.21L107.45,130.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.54,142.08c1.03,0.59,2.36,0.75,3.34,0.4c-0.33,0.12-0.64,0.12-0.88-0.03c-0.3-0.2-0.51-0.6-0.52-1.16 c-0.05-1.17,0.68-2.61,1.63-3.23c0.48-0.31,0.92-0.35,1.25-0.15c0.24,0.15,0.41,0.43,0.48,0.81c-0.28-1.35-1.23-2.39-2.01-2.9 c-0.46-0.29-1.08-0.25-1.76,0.19c-1.3,0.86-2.31,2.86-2.24,4.47C100.84,141.26,101.12,141.81,101.54,142.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.83,138.72c0.1,0.3,0.46,0.89,0.9,1.2c-0.2-0.12-0.47-0.1-0.77,0.1c-0.58,0.38-1.02,1.27-0.99,1.98 c0.02,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.32-0.15c-0.34-0.1-0.75-0.14-1.08-0.08c-0.33,0.12-0.64,0.12-0.88-0.03 c-0.3-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.68-2.61,1.63-3.23c0.48-0.31,0.92-0.35,1.25-0.15 C106.58,138.06,106.76,138.34,106.83,138.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104.78,137.58c-0.64-0.4-1.59,0.1-2.11,1.11c-0.52,1.01-0.42,2.14,0.23,2.54 c0.64,0.39,1.58-0.1,2.1-1.11C105.53,139.11,105.43,137.97,104.78,137.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M106.28,142.7l2.15,1.32c-0.19-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.43-1.6,1-1.97 c0.3-0.2,0.57-0.22,0.77-0.1l-2.15-1.32c-0.2-0.12-0.47-0.1-0.77,0.1c-0.58,0.38-1.02,1.27-0.99,1.98 C105.98,142.34,106.09,142.58,106.28,142.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M110.19,141.95c-0.03-0.72-0.51-0.99-1.09-0.62c-0.57,0.38-1.02,1.27-1,1.97c0.03,0.72,0.51,1,1.09,0.62 C109.77,143.55,110.21,142.66,110.19,141.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90.57,135.33l10.97,6.75c-0.42-0.27-0.69-0.81-0.72-1.6c-0.07-1.61,0.94-3.61,2.24-4.47 c0.68-0.44,1.29-0.48,1.74-0.2l-10.99-6.76c-0.45-0.28-1.09-0.21-1.75,0.23c-1.3,0.83-2.29,2.84-2.23,4.46 C89.86,134.52,90.14,135.06,90.57,135.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M94.36,130.79c-0.06-1.49-1.08-2.07-2.3-1.28c-1.2,0.77-2.12,2.64-2.08,4.13c0.08,1.5,1.1,2.09,2.31,1.3 C93.49,134.14,94.41,132.28,94.36,130.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M94.17,131.32c-0.04-1.15-0.84-1.59-1.76-0.99c-0.92,0.6-1.63,2.03-1.59,3.17c0.05,1.16,0.84,1.61,1.76,1 C93.51,133.89,94.21,132.46,94.17,131.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M101.86,134.01c-0.43-0.26-1.03-0.22-1.68,0.21c-0.62,0.4-1.17,1.09-1.56,1.85l-5.09-3.11 c0.4-0.78,0.95-1.46,1.57-1.87c0.65-0.43,1.25-0.48,1.69-0.21L101.86,134.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.98,145.58c1.02,0.59,2.36,0.75,3.33,0.4c-0.33,0.12-0.64,0.12-0.88-0.03c-0.3-0.2-0.51-0.6-0.52-1.16 c-0.05-1.17,0.67-2.61,1.61-3.23c0.48-0.31,0.92-0.35,1.25-0.15c0.24,0.15,0.41,0.43,0.48,0.81c-0.29-1.35-1.23-2.39-2.02-2.9 c-0.46-0.29-1.08-0.25-1.75,0.19c-1.3,0.86-2.29,2.86-2.22,4.47C95.29,144.77,95.56,145.31,95.98,145.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.26,142.22c0.1,0.3,0.46,0.89,0.9,1.2c-0.2-0.12-0.47-0.1-0.76,0.1c-0.57,0.38-1.02,1.27-0.99,1.98 c0.02,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.32-0.15c-0.33-0.1-0.75-0.14-1.08-0.08c-0.33,0.12-0.64,0.12-0.88-0.03 c-0.3-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.67-2.61,1.61-3.23c0.48-0.31,0.92-0.35,1.25-0.15 C101.01,141.56,101.18,141.84,101.26,142.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.21,141.08c-0.65-0.4-1.59,0.1-2.1,1.11c-0.52,1.01-0.41,2.14,0.24,2.54c0.64,0.39,1.58-0.1,2.1-1.11 C99.96,142.62,99.86,141.48,99.21,141.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M100.72,146.2l2.15,1.32c-0.19-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.42-1.6,1-1.97 c0.3-0.2,0.57-0.22,0.76-0.1l-2.15-1.32c-0.2-0.12-0.47-0.1-0.76,0.1c-0.57,0.38-1.02,1.27-0.99,1.98 C100.41,145.84,100.53,146.09,100.72,146.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M104.62,145.46c-0.03-0.72-0.51-0.99-1.09-0.62c-0.57,0.38-1.02,1.27-1,1.97c0.03,0.72,0.51,1,1.1,0.62 C104.21,147.05,104.65,146.16,104.62,145.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.02,138.83l10.97,6.75c-0.42-0.27-0.7-0.81-0.72-1.6c-0.07-1.61,0.92-3.61,2.22-4.47 c0.68-0.44,1.29-0.48,1.74-0.2l-10.99-6.76c-0.45-0.27-1.08-0.21-1.74,0.23c-1.3,0.83-2.28,2.84-2.21,4.46 C84.31,138.02,84.59,138.57,85.02,138.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M88.78,134.29c-0.07-1.49-1.09-2.07-2.3-1.28c-1.2,0.77-2.11,2.64-2.06,4.13c0.08,1.5,1.1,2.09,2.3,1.3 C87.93,137.65,88.84,135.79,88.78,134.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M88.6,134.82c-0.05-1.15-0.84-1.59-1.76-0.99c-0.92,0.6-1.62,2.03-1.58,3.16c0.06,1.16,0.85,1.61,1.76,1 C87.95,137.39,88.64,135.96,88.6,134.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M96.28,137.51c-0.43-0.26-1.03-0.22-1.68,0.21c-0.61,0.4-1.16,1.09-1.55,1.85l-5.09-3.1 c0.39-0.78,0.95-1.46,1.56-1.87c0.65-0.43,1.24-0.48,1.68-0.21L96.28,137.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90.45,149.09c1.03,0.59,2.36,0.75,3.33,0.4c-0.33,0.12-0.64,0.12-0.88-0.03c-0.3-0.2-0.51-0.6-0.53-1.16 c-0.06-1.17,0.66-2.61,1.6-3.23c0.48-0.31,0.92-0.35,1.24-0.15c0.24,0.15,0.41,0.43,0.48,0.81c-0.29-1.35-1.24-2.39-2.02-2.9 c-0.46-0.29-1.08-0.25-1.75,0.19c-1.29,0.86-2.28,2.86-2.2,4.47C89.75,148.27,90.03,148.82,90.45,149.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.7,145.73c0.1,0.3,0.46,0.89,0.9,1.2c-0.2-0.12-0.47-0.1-0.77,0.1c-0.57,0.38-1.01,1.27-0.98,1.98 c0.02,0.34,0.14,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.32-0.15c-0.34-0.1-0.75-0.14-1.08-0.08c-0.33,0.12-0.64,0.12-0.88-0.03 c-0.3-0.2-0.51-0.6-0.53-1.16c-0.06-1.17,0.66-2.61,1.6-3.23c0.48-0.31,0.92-0.35,1.24-0.15 C95.45,145.06,95.63,145.35,95.7,145.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M93.66,144.59c-0.65-0.4-1.58,0.1-2.1,1.11c-0.51,1.01-0.4,2.14,0.25,2.54c0.64,0.39,1.58-0.1,2.09-1.11 C94.42,146.12,94.3,144.98,93.66,144.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M95.18,149.71l2.15,1.32c-0.19-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.42-1.6,0.99-1.98 c0.3-0.2,0.57-0.22,0.77-0.1l-2.15-1.32c-0.2-0.12-0.47-0.1-0.77,0.1c-0.57,0.38-1.01,1.27-0.98,1.98 C94.87,149.35,94.99,149.59,95.18,149.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M99.08,148.96c-0.03-0.72-0.52-0.99-1.09-0.62c-0.57,0.38-1.01,1.27-0.99,1.98c0.03,0.72,0.52,1,1.1,0.62 C98.66,150.56,99.1,149.67,99.08,148.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M79.48,142.34l10.97,6.75c-0.42-0.27-0.7-0.81-0.72-1.6c-0.08-1.61,0.91-3.61,2.2-4.47 c0.67-0.44,1.29-0.48,1.73-0.2l-10.99-6.76c-0.45-0.27-1.08-0.21-1.74,0.23c-1.29,0.83-2.27,2.84-2.19,4.46 C78.78,141.53,79.06,142.07,79.48,142.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M83.23,137.79c-0.07-1.49-1.09-2.07-2.3-1.28c-1.19,0.77-2.1,2.64-2.04,4.13c0.09,1.5,1.11,2.09,2.31,1.3 C82.39,141.15,83.29,139.29,83.23,137.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M83.04,138.33c-0.05-1.15-0.84-1.59-1.76-0.99c-0.92,0.6-1.61,2.03-1.56,3.17c0.06,1.16,0.85,1.61,1.76,1 C82.4,140.9,83.09,139.46,83.04,138.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M90.72,141.01c-0.43-0.26-1.03-0.22-1.67,0.21c-0.61,0.4-1.16,1.09-1.54,1.85l-5.09-3.1 c0.39-0.78,0.94-1.47,1.55-1.87c0.64-0.43,1.24-0.48,1.68-0.21L90.72,141.01z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.1594,
    y1: 124.4417,
    x2: 107.0308,
    y2: 148.6626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2ECF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    style: {
      stopColor: "#D6EEF9",
      stopOpacity: 0.7115
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6032,
    style: {
      stopColor: "#E4F3FB",
      stopOpacity: 0.3968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#F9FDFE",
      stopOpacity: 0.0707
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "120.34,135.52 88.28,155.59 87.88,138.9 120.23,118.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.4092,
    y1: 154.0071,
    x2: 97.5062,
    y2: 128.5013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2956,
    style: {
      stopColor: "#C3926B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#D19B72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9522,
    style: {
      stopColor: "#E6AA7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAAD7E"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "70.78,133.76 107.92,110.53 125.3,121.18 88.16,144.41  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "70.78,133.76 70.84,135.85 88.21,146.5 88.16,144.41  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "125.3,121.18 125.31,123.27 88.21,146.5 88.16,144.41  "
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.16,144.41c5.86-4.36,11.95-8.34,18.12-12.23c6.21-3.85,12.5-7.61,19.02-11 c-5.99,4.36-12.15,8.34-18.35,12.23C100.77,137.26,94.55,141.02,88.16,144.41z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "119.56,126.83 119.54,124.74 102.16,114.09  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "114.21,130.15 114.19,128.06 96.81,117.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "108.89,133.48 108.86,131.38 91.48,120.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "103.59,136.8 103.55,134.7 86.17,124.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "98.3,140.12 98.26,138.03 80.88,127.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "93.03,143.45 92.99,141.35 75.61,130.71  "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.55,120.74c1.03,0.59,2.39,0.75,3.37,0.4c-0.34,0.12-0.65,0.12-0.89-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.04-1.17,0.7-2.61,1.66-3.23c0.49-0.31,0.93-0.35,1.26-0.15c0.24,0.15,0.42,0.43,0.48,0.81 c-0.28-1.35-1.23-2.39-2.02-2.9c-0.47-0.3-1.09-0.25-1.78,0.19c-1.32,0.86-2.35,2.85-2.29,4.46 C111.85,119.92,112.13,120.47,112.55,120.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.92,117.38c0.1,0.3,0.46,0.89,0.9,1.2c-0.2-0.12-0.48-0.1-0.78,0.09c-0.59,0.38-1.04,1.27-1.02,1.98 c0.01,0.34,0.13,0.59,0.31,0.7c-0.09-0.05-0.21-0.1-0.32-0.15c-0.34-0.1-0.76-0.14-1.09-0.08c-0.34,0.12-0.65,0.12-0.89-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.04-1.17,0.7-2.61,1.66-3.23c0.49-0.31,0.93-0.35,1.26-0.15 C117.68,116.72,117.85,117,117.92,117.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115.86,116.24c-0.65-0.4-1.61,0.1-2.14,1.11c-0.53,1.01-0.43,2.14,0.22,2.54c0.65,0.39,1.6-0.1,2.13-1.1 C116.61,117.77,116.51,116.64,115.86,116.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M117.34,121.36l2.17,1.32c-0.19-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.44-1.6,1.03-1.97 c0.31-0.2,0.58-0.22,0.78-0.1l-2.16-1.32c-0.2-0.12-0.48-0.1-0.78,0.09c-0.59,0.38-1.04,1.27-1.02,1.98 C117.04,121,117.15,121.25,117.34,121.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M121.3,120.62c-0.03-0.72-0.51-0.99-1.1-0.62c-0.59,0.38-1.04,1.27-1.03,1.97c0.02,0.72,0.51,1,1.1,0.62 C120.87,122.21,121.32,121.32,121.3,120.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.5,113.99l11.05,6.75c-0.42-0.27-0.7-0.81-0.72-1.6c-0.06-1.61,0.97-3.61,2.29-4.46 c0.69-0.44,1.31-0.48,1.76-0.2l-11.07-6.77c-0.46-0.28-1.1-0.21-1.77,0.23c-1.32,0.83-2.34,2.84-2.28,4.46 C100.79,113.17,101.07,113.72,101.5,113.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M105.36,109.45c-0.05-1.49-1.08-2.07-2.31-1.28c-1.22,0.77-2.17,2.64-2.13,4.13 c0.07,1.5,1.1,2.09,2.32,1.3C104.46,112.8,105.4,110.94,105.36,109.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M105.16,109.98c-0.04-1.15-0.84-1.59-1.77-0.99c-0.94,0.6-1.66,2.03-1.63,3.16c0.05,1.16,0.84,1.6,1.78,1 C104.48,112.55,105.2,111.12,105.16,109.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M112.92,112.67c-0.44-0.26-1.05-0.22-1.7,0.21c-0.63,0.4-1.19,1.09-1.59,1.85l-5.13-3.11 c0.41-0.78,0.97-1.46,1.6-1.87c0.66-0.43,1.26-0.48,1.71-0.21L112.92,112.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.91,124.24c1.03,0.59,2.38,0.75,3.36,0.4c-0.34,0.12-0.65,0.12-0.89-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.69-2.61,1.65-3.23c0.49-0.31,0.93-0.35,1.26-0.15c0.24,0.15,0.42,0.43,0.48,0.81 c-0.28-1.35-1.23-2.39-2.02-2.9c-0.47-0.29-1.09-0.25-1.78,0.19c-1.32,0.86-2.33,2.85-2.27,4.47 C106.21,123.43,106.49,123.97,106.91,124.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.26,120.88c0.1,0.3,0.46,0.89,0.9,1.2c-0.2-0.12-0.48-0.1-0.78,0.09c-0.58,0.38-1.04,1.27-1.01,1.98 c0.01,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.33-0.15c-0.34-0.1-0.76-0.14-1.09-0.08c-0.34,0.12-0.65,0.12-0.89-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.69-2.61,1.65-3.23c0.49-0.31,0.93-0.35,1.26-0.15 C112.02,120.22,112.19,120.5,112.26,120.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M110.2,119.74c-0.65-0.4-1.61,0.1-2.13,1.11c-0.53,1.01-0.43,2.14,0.22,2.54c0.65,0.39,1.6-0.1,2.13-1.1 C110.95,121.28,110.85,120.14,110.2,119.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M111.69,124.86l2.16,1.32c-0.19-0.12-0.31-0.36-0.32-0.71c-0.02-0.71,0.44-1.6,1.02-1.97 c0.3-0.2,0.58-0.22,0.77-0.1l-2.16-1.32c-0.2-0.12-0.48-0.1-0.78,0.09c-0.58,0.38-1.04,1.27-1.01,1.98 C111.39,124.5,111.51,124.75,111.69,124.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M115.65,124.12c-0.02-0.72-0.51-0.99-1.1-0.62c-0.58,0.38-1.04,1.27-1.02,1.97c0.03,0.72,0.51,1,1.1,0.62 C115.22,125.71,115.67,124.82,115.65,124.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.86,117.49l11.05,6.75c-0.42-0.27-0.7-0.81-0.72-1.6c-0.06-1.61,0.95-3.61,2.27-4.47 c0.69-0.44,1.31-0.48,1.76-0.2l-11.07-6.77c-0.46-0.28-1.09-0.21-1.77,0.23c-1.31,0.83-2.32,2.84-2.26,4.46 C95.15,116.68,95.43,117.22,95.86,117.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M99.7,112.95c-0.06-1.49-1.09-2.07-2.32-1.28c-1.22,0.77-2.15,2.64-2.11,4.13c0.07,1.5,1.1,2.09,2.32,1.3 C98.82,116.3,99.75,114.44,99.7,112.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M99.51,113.48c-0.04-1.15-0.84-1.59-1.77-0.99c-0.93,0.6-1.65,2.03-1.62,3.16c0.05,1.16,0.85,1.61,1.78,1 C98.83,116.05,99.54,114.62,99.51,113.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M107.26,116.17c-0.44-0.26-1.04-0.22-1.7,0.21c-0.62,0.4-1.18,1.09-1.58,1.85l-5.13-3.11 c0.4-0.78,0.97-1.46,1.59-1.87c0.66-0.43,1.26-0.48,1.7-0.21L107.26,116.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.29,127.74c1.03,0.59,2.38,0.75,3.36,0.4c-0.34,0.12-0.65,0.11-0.89-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.68-2.61,1.64-3.23c0.48-0.31,0.93-0.35,1.26-0.15c0.24,0.15,0.42,0.43,0.48,0.81 c-0.28-1.35-1.24-2.39-2.03-2.9c-0.47-0.29-1.09-0.25-1.77,0.19c-1.31,0.86-2.32,2.85-2.25,4.47 C100.59,126.93,100.87,127.47,101.29,127.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.62,124.38c0.1,0.3,0.46,0.89,0.9,1.2c-0.2-0.12-0.48-0.1-0.78,0.1c-0.58,0.38-1.03,1.27-1,1.98 c0.02,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.33-0.15c-0.34-0.1-0.76-0.14-1.09-0.08c-0.34,0.12-0.65,0.11-0.89-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.68-2.61,1.64-3.23c0.48-0.31,0.93-0.35,1.26-0.15 C106.38,123.72,106.55,124,106.62,124.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104.57,123.25c-0.65-0.4-1.6,0.1-2.12,1.11c-0.52,1.01-0.42,2.14,0.23,2.54c0.65,0.39,1.6-0.1,2.12-1.11 C105.32,124.78,105.22,123.64,104.57,123.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M106.07,128.36l2.16,1.32c-0.19-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.43-1.6,1.01-1.97 c0.3-0.2,0.58-0.22,0.77-0.1l-2.16-1.32c-0.2-0.12-0.48-0.1-0.78,0.1c-0.58,0.38-1.03,1.27-1,1.98 C105.77,128,105.88,128.25,106.07,128.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M110.02,127.62c-0.03-0.72-0.52-0.99-1.1-0.62c-0.58,0.38-1.03,1.27-1.01,1.97c0.03,0.72,0.52,1,1.1,0.62 C109.59,129.21,110.04,128.32,110.02,127.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90.24,120.99l11.05,6.75c-0.42-0.27-0.7-0.81-0.72-1.6c-0.07-1.61,0.94-3.61,2.25-4.47 c0.68-0.44,1.3-0.48,1.75-0.2l-11.07-6.77c-0.46-0.28-1.1-0.21-1.76,0.23c-1.31,0.83-2.31,2.84-2.25,4.46 C89.53,120.18,89.82,120.73,90.24,120.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M94.06,116.45c-0.06-1.49-1.09-2.07-2.31-1.28c-1.21,0.77-2.14,2.64-2.09,4.13 c0.08,1.5,1.1,2.09,2.32,1.3C93.19,119.81,94.11,117.95,94.06,116.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M93.87,116.98c-0.04-1.15-0.84-1.59-1.77-0.99c-0.93,0.6-1.64,2.03-1.6,3.17c0.05,1.16,0.85,1.61,1.78,1 C93.21,119.55,93.91,118.12,93.87,116.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M101.62,119.67c-0.44-0.26-1.04-0.22-1.69,0.21c-0.62,0.4-1.18,1.09-1.57,1.85l-5.13-3.11 c0.4-0.78,0.96-1.46,1.58-1.87c0.65-0.43,1.26-0.48,1.7-0.21L101.62,119.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.7,131.24c1.03,0.59,2.38,0.75,3.35,0.4c-0.33,0.12-0.64,0.12-0.89-0.03c-0.31-0.2-0.51-0.6-0.52-1.16 c-0.05-1.17,0.67-2.61,1.62-3.23c0.48-0.31,0.93-0.35,1.26-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.29-1.35-1.24-2.39-2.03-2.9 c-0.47-0.29-1.09-0.25-1.77,0.19c-1.31,0.86-2.31,2.86-2.23,4.47C95,130.43,95.27,130.97,95.7,131.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.01,127.89c0.1,0.3,0.46,0.89,0.9,1.2c-0.2-0.12-0.48-0.1-0.77,0.1c-0.58,0.38-1.03,1.27-1,1.98 c0.02,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.33-0.15c-0.34-0.1-0.76-0.14-1.09-0.08c-0.33,0.12-0.64,0.12-0.89-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.67-2.61,1.62-3.23c0.48-0.31,0.93-0.35,1.26-0.15 C100.76,127.23,100.94,127.51,101.01,127.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M98.95,126.75c-0.65-0.4-1.6,0.1-2.12,1.11c-0.52,1.01-0.41,2.14,0.24,2.54c0.65,0.39,1.59-0.1,2.11-1.11 C99.71,128.28,99.6,127.14,98.95,126.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M100.47,131.87l2.16,1.33c-0.19-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.43-1.6,1.01-1.97 c0.3-0.2,0.57-0.22,0.77-0.1l-2.16-1.32c-0.2-0.12-0.48-0.1-0.77,0.1c-0.58,0.38-1.03,1.27-1,1.98 C100.16,131.51,100.28,131.75,100.47,131.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M104.4,131.12c-0.03-0.72-0.52-0.99-1.1-0.62c-0.58,0.38-1.03,1.27-1.01,1.97c0.03,0.72,0.52,1,1.1,0.62 C103.98,132.72,104.43,131.83,104.4,131.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.65,124.49l11.05,6.75c-0.42-0.27-0.7-0.81-0.73-1.6c-0.07-1.61,0.93-3.61,2.23-4.47 c0.68-0.44,1.3-0.48,1.75-0.2l-11.07-6.77c-0.46-0.28-1.09-0.21-1.76,0.23c-1.31,0.83-2.3,2.84-2.23,4.46 C83.93,123.68,84.22,124.23,84.65,124.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M88.44,119.95c-0.07-1.49-1.1-2.07-2.32-1.28c-1.21,0.77-2.13,2.64-2.07,4.13 c0.08,1.5,1.11,2.09,2.32,1.3C87.59,123.31,88.5,121.45,88.44,119.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M88.26,120.49c-0.05-1.15-0.85-1.59-1.77-0.99c-0.93,0.6-1.63,2.03-1.59,3.17c0.06,1.16,0.85,1.61,1.78,1 C87.6,123.06,88.3,121.62,88.26,120.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M95.99,123.17c-0.43-0.26-1.04-0.22-1.69,0.21c-0.62,0.4-1.17,1.09-1.56,1.85l-5.13-3.11 c0.4-0.78,0.95-1.46,1.57-1.87c0.65-0.43,1.25-0.48,1.7-0.21L95.99,123.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90.12,134.75c1.03,0.59,2.38,0.75,3.35,0.4c-0.33,0.12-0.64,0.11-0.89-0.03c-0.31-0.2-0.51-0.6-0.53-1.16 c-0.06-1.17,0.67-2.61,1.61-3.23c0.48-0.31,0.92-0.35,1.25-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.29-1.35-1.25-2.39-2.04-2.9 c-0.47-0.29-1.09-0.25-1.76,0.19c-1.3,0.86-2.3,2.86-2.22,4.47C89.42,133.93,89.7,134.48,90.12,134.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.41,131.39c0.1,0.3,0.46,0.89,0.91,1.2c-0.2-0.12-0.48-0.1-0.77,0.1c-0.58,0.38-1.02,1.27-0.99,1.98 c0.02,0.34,0.14,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.33-0.15c-0.34-0.1-0.75-0.14-1.08-0.08c-0.33,0.12-0.64,0.11-0.89-0.03 c-0.31-0.2-0.51-0.6-0.53-1.16c-0.06-1.17,0.67-2.61,1.61-3.23c0.48-0.31,0.92-0.35,1.25-0.15 C95.16,130.73,95.34,131.01,95.41,131.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M93.36,130.25c-0.65-0.4-1.6,0.1-2.11,1.11c-0.51,1.01-0.4,2.14,0.25,2.54c0.65,0.39,1.59-0.1,2.11-1.11 C94.12,131.78,94.01,130.65,93.36,130.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M94.88,135.37l2.16,1.33c-0.19-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.42-1.6,1-1.97 c0.3-0.2,0.57-0.22,0.77-0.1l-2.16-1.32c-0.2-0.12-0.48-0.1-0.77,0.1c-0.58,0.38-1.02,1.27-0.99,1.98 C94.58,135.01,94.7,135.26,94.88,135.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M98.81,134.62c-0.03-0.72-0.52-0.99-1.1-0.62c-0.57,0.38-1.02,1.27-1,1.97c0.03,0.72,0.52,1,1.1,0.62 C98.4,136.22,98.84,135.33,98.81,134.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M79.07,128l11.05,6.75c-0.42-0.27-0.7-0.81-0.73-1.6c-0.08-1.61,0.92-3.61,2.22-4.47 c0.68-0.44,1.3-0.48,1.74-0.2l-11.07-6.77c-0.46-0.28-1.09-0.21-1.76,0.23c-1.3,0.83-2.28,2.84-2.21,4.46 C78.36,127.19,78.64,127.73,79.07,128"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M82.85,123.46c-0.07-1.49-1.1-2.07-2.31-1.28c-1.2,0.77-2.12,2.64-2.06,4.13c0.09,1.5,1.11,2.09,2.32,1.3 C82,126.81,82.91,124.95,82.85,123.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M82.66,123.99c-0.05-1.15-0.85-1.59-1.77-0.99c-0.92,0.6-1.62,2.03-1.58,3.17c0.06,1.16,0.85,1.61,1.78,1 C82.02,126.56,82.71,125.13,82.66,123.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M90.4,126.68c-0.44-0.26-1.04-0.22-1.69,0.21c-0.61,0.4-1.16,1.09-1.55,1.85l-5.13-3.11 c0.39-0.78,0.95-1.46,1.56-1.87c0.65-0.43,1.25-0.48,1.69-0.21L90.4,126.68z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.896,
    y1: 107.013,
    x2: 106.7511,
    y2: 131.167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2ECF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    style: {
      stopColor: "#D6EEF9",
      stopOpacity: 0.7115
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6032,
    style: {
      stopColor: "#E4F3FB",
      stopOpacity: 0.3968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#F9FDFE",
      stopOpacity: 0.0707
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "120.22,118.06 87.86,138.12 87.46,121.43 120.11,101.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.054,
    y1: 136.5965,
    x2: 97.1781,
    y2: 111.0379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2956,
    style: {
      stopColor: "#C3926B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#D19B72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9522,
    style: {
      stopColor: "#E6AA7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAAD7E"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "70.2,116.29 107.68,93.07 125.22,103.72 87.74,126.94  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "70.2,116.29 70.26,118.38 87.79,129.03 87.74,126.94  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "125.22,103.72 125.23,105.81 87.79,129.03 87.74,126.94  "
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.74,126.94c5.91-4.36,12.06-8.34,18.28-12.23c6.27-3.85,12.62-7.61,19.2-10.99 c-6.04,4.36-12.27,8.34-18.51,12.22C100.46,119.79,94.19,123.55,87.74,126.94z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "119.43,109.37 119.42,107.28 101.87,96.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "114.04,112.69 114.01,110.6 96.48,99.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "108.66,116.01 108.64,113.92 91.1,103.27  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "103.31,119.34 103.28,117.24 85.74,106.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "97.97,122.66 97.94,120.56 80.39,109.91  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "92.66,125.98 92.61,123.88 75.07,113.24  "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.35,103.17c1.04,0.59,2.41,0.75,3.4,0.4c-0.34,0.12-0.66,0.12-0.9-0.03c-0.31-0.2-0.51-0.6-0.52-1.16 c-0.04-1.17,0.71-2.61,1.68-3.23c0.49-0.31,0.94-0.35,1.28-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.28-1.35-1.24-2.39-2.03-2.9 c-0.47-0.3-1.1-0.25-1.8,0.19c-1.33,0.86-2.37,2.85-2.31,4.46C111.65,102.35,111.93,102.9,112.35,103.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.78,99.81c0.1,0.3,0.46,0.89,0.91,1.2c-0.2-0.12-0.48-0.1-0.78,0.09c-0.59,0.38-1.05,1.27-1.03,1.98 c0.01,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.33-0.15c-0.34-0.1-0.77-0.14-1.1-0.08c-0.34,0.12-0.66,0.12-0.9-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.04-1.17,0.71-2.61,1.68-3.23c0.49-0.31,0.94-0.35,1.28-0.15 C117.53,99.15,117.71,99.43,117.78,99.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115.7,98.67c-0.65-0.4-1.62,0.1-2.16,1.11c-0.53,1.01-0.44,2.14,0.22,2.54c0.65,0.39,1.62-0.1,2.15-1.1 C116.45,100.2,116.35,99.07,115.7,98.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M117.19,103.79l2.19,1.33c-0.2-0.12-0.32-0.36-0.33-0.71c-0.02-0.71,0.45-1.6,1.04-1.97 c0.31-0.2,0.59-0.22,0.79-0.1l-2.18-1.32c-0.2-0.12-0.48-0.1-0.78,0.09c-0.59,0.38-1.05,1.27-1.03,1.98 C116.88,103.43,117,103.68,117.19,103.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M121.19,103.05c-0.03-0.72-0.52-0.99-1.11-0.62c-0.59,0.38-1.05,1.27-1.04,1.97 c0.02,0.72,0.52,1,1.11,0.62C120.75,104.64,121.21,103.75,121.19,103.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.2,96.41l11.15,6.75c-0.43-0.27-0.7-0.81-0.72-1.6c-0.06-1.61,0.98-3.61,2.31-4.46 c0.69-0.44,1.32-0.48,1.77-0.2l-11.17-6.77c-0.46-0.28-1.11-0.21-1.79,0.23c-1.33,0.83-2.36,2.84-2.3,4.46 C100.49,95.6,100.77,96.15,101.2,96.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M105.1,91.88c-0.05-1.49-1.09-2.07-2.34-1.28c-1.23,0.77-2.19,2.64-2.15,4.13 c0.07,1.5,1.11,2.09,2.35,1.3C104.2,95.23,105.14,93.37,105.1,91.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M104.9,92.41c-0.04-1.15-0.84-1.59-1.79-0.99c-0.95,0.6-1.68,2.03-1.64,3.16c0.05,1.16,0.85,1.61,1.79,1 C104.21,94.98,104.94,93.55,104.9,92.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M112.73,95.1c-0.44-0.26-1.06-0.22-1.72,0.21c-0.63,0.4-1.2,1.09-1.6,1.85l-5.18-3.11 c0.41-0.78,0.98-1.46,1.61-1.87c0.67-0.43,1.27-0.48,1.72-0.21L112.73,95.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.67,106.67c1.04,0.59,2.41,0.75,3.4,0.4c-0.34,0.12-0.65,0.12-0.9-0.03c-0.31-0.2-0.51-0.6-0.52-1.16 c-0.05-1.17,0.7-2.61,1.66-3.23c0.49-0.31,0.94-0.35,1.28-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.29-1.35-1.24-2.39-2.04-2.9 c-0.47-0.29-1.1-0.25-1.79,0.19c-1.33,0.86-2.36,2.85-2.29,4.46C105.96,105.85,106.24,106.4,106.67,106.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.07,103.31c0.1,0.3,0.46,0.89,0.91,1.2c-0.2-0.12-0.48-0.1-0.78,0.09c-0.59,0.38-1.05,1.27-1.02,1.98 c0.01,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.33-0.15c-0.34-0.1-0.76-0.14-1.1-0.08c-0.34,0.12-0.65,0.12-0.9-0.03 c-0.31-0.2-0.51-0.6-0.52-1.16c-0.05-1.17,0.7-2.61,1.66-3.23c0.49-0.31,0.94-0.35,1.28-0.15 C111.82,102.65,112,102.93,112.07,103.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.99,102.17c-0.66-0.4-1.62,0.1-2.15,1.11c-0.53,1.01-0.43,2.14,0.23,2.54 c0.65,0.39,1.61-0.1,2.15-1.1C110.75,103.7,110.64,102.57,109.99,102.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M111.49,107.29l2.18,1.33c-0.19-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.44-1.6,1.03-1.97 c0.31-0.19,0.58-0.22,0.78-0.1l-2.18-1.32c-0.2-0.12-0.48-0.1-0.78,0.09c-0.59,0.38-1.05,1.27-1.02,1.98 C111.18,106.93,111.3,107.18,111.49,107.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M115.48,106.55c-0.03-0.72-0.52-0.99-1.11-0.62c-0.59,0.38-1.05,1.27-1.03,1.97 c0.03,0.72,0.52,1,1.11,0.62C115.05,108.14,115.5,107.25,115.48,106.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.52,99.91l11.15,6.75c-0.43-0.27-0.71-0.81-0.73-1.6c-0.07-1.61,0.96-3.61,2.29-4.46 c0.69-0.44,1.32-0.48,1.77-0.2l-11.17-6.77c-0.46-0.28-1.1-0.21-1.78,0.23c-1.32,0.83-2.34,2.84-2.28,4.46 C94.8,99.1,95.08,99.65,95.52,99.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M99.39,95.38c-0.06-1.49-1.1-2.07-2.34-1.28c-1.23,0.77-2.17,2.64-2.13,4.13c0.07,1.5,1.11,2.09,2.34,1.3 C98.5,98.73,99.44,96.87,99.39,95.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M99.19,95.91c-0.04-1.15-0.85-1.59-1.79-0.99c-0.94,0.6-1.67,2.03-1.63,3.16c0.05,1.16,0.85,1.61,1.79,1 C98.51,98.48,99.23,97.05,99.19,95.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M107.02,98.6c-0.44-0.26-1.05-0.22-1.71,0.21c-0.63,0.4-1.19,1.09-1.59,1.85l-5.18-3.11 c0.41-0.78,0.98-1.46,1.61-1.87c0.66-0.43,1.27-0.48,1.72-0.21L107.02,98.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.99,110.17c1.04,0.59,2.4,0.75,3.39,0.4c-0.34,0.12-0.65,0.11-0.9-0.03c-0.31-0.2-0.51-0.6-0.53-1.16 c-0.05-1.17,0.69-2.61,1.65-3.23c0.49-0.31,0.94-0.35,1.27-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.29-1.35-1.25-2.39-2.04-2.9 c-0.47-0.29-1.1-0.25-1.79,0.19c-1.32,0.86-2.35,2.85-2.28,4.46C100.29,109.35,100.57,109.9,100.99,110.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.38,106.81c0.1,0.3,0.46,0.89,0.91,1.2c-0.2-0.12-0.48-0.1-0.78,0.1c-0.59,0.38-1.04,1.27-1.01,1.98 c0.02,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.22-0.1-0.33-0.15c-0.34-0.1-0.76-0.14-1.1-0.08c-0.34,0.12-0.65,0.11-0.9-0.03 c-0.31-0.2-0.51-0.6-0.53-1.16c-0.05-1.17,0.69-2.61,1.65-3.23c0.49-0.31,0.94-0.35,1.27-0.15 C106.13,106.15,106.31,106.43,106.38,106.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104.3,105.67c-0.65-0.4-1.61,0.1-2.14,1.11c-0.53,1.01-0.42,2.14,0.24,2.54c0.65,0.39,1.61-0.1,2.14-1.1 C105.06,107.21,104.95,106.07,104.3,105.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M105.82,110.79l2.18,1.33c-0.2-0.12-0.32-0.36-0.33-0.71c-0.02-0.71,0.44-1.6,1.02-1.97 c0.31-0.19,0.58-0.22,0.78-0.1l-2.18-1.32c-0.2-0.12-0.48-0.1-0.78,0.1c-0.59,0.38-1.04,1.27-1.01,1.98 C105.51,110.43,105.63,110.68,105.82,110.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M109.8,110.05c-0.03-0.72-0.52-0.99-1.11-0.62c-0.58,0.38-1.04,1.27-1.02,1.97 c0.03,0.72,0.52,1,1.11,0.62C109.37,111.64,109.82,110.75,109.8,110.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.84,103.42l11.15,6.75c-0.43-0.27-0.71-0.81-0.73-1.6c-0.07-1.61,0.95-3.61,2.28-4.46 c0.69-0.44,1.32-0.48,1.77-0.2l-11.17-6.77c-0.46-0.28-1.11-0.21-1.78,0.23c-1.32,0.83-2.33,2.84-2.27,4.46 C89.13,102.6,89.41,103.15,89.84,103.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M93.7,98.88c-0.06-1.49-1.1-2.07-2.33-1.28c-1.22,0.77-2.16,2.64-2.11,4.13c0.08,1.5,1.11,2.09,2.34,1.3 C92.82,102.23,93.75,100.37,93.7,98.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M93.5,99.41c-0.04-1.15-0.85-1.59-1.79-0.99c-0.94,0.6-1.66,2.03-1.62,3.16c0.05,1.16,0.85,1.61,1.79,1 C92.84,101.98,93.55,100.55,93.5,99.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M101.32,102.1c-0.44-0.26-1.05-0.22-1.71,0.21c-0.63,0.4-1.19,1.09-1.59,1.85l-5.18-3.11 c0.4-0.78,0.97-1.46,1.6-1.87c0.66-0.43,1.27-0.48,1.72-0.21L101.32,102.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.35,113.67c1.04,0.59,2.4,0.75,3.39,0.4c-0.34,0.12-0.65,0.11-0.9-0.03c-0.31-0.2-0.52-0.6-0.53-1.16 c-0.05-1.17,0.68-2.61,1.64-3.23c0.49-0.31,0.94-0.35,1.27-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.29-1.35-1.25-2.39-2.05-2.9 c-0.47-0.29-1.1-0.25-1.78,0.19c-1.32,0.86-2.33,2.85-2.26,4.47C94.64,112.86,94.92,113.4,95.35,113.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.71,110.31c0.1,0.3,0.47,0.89,0.91,1.2c-0.2-0.12-0.48-0.1-0.78,0.1c-0.58,0.38-1.04,1.27-1.01,1.98 c0.02,0.34,0.14,0.59,0.32,0.7c-0.09-0.05-0.21-0.1-0.33-0.15c-0.34-0.1-0.76-0.14-1.1-0.08c-0.34,0.12-0.65,0.11-0.9-0.03 c-0.31-0.2-0.52-0.6-0.53-1.16c-0.05-1.17,0.68-2.61,1.64-3.23c0.49-0.31,0.94-0.35,1.27-0.15 C100.46,109.65,100.64,109.93,100.71,110.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M98.63,109.18c-0.66-0.4-1.61,0.1-2.14,1.11c-0.52,1.01-0.42,2.14,0.24,2.54 c0.65,0.39,1.61-0.1,2.13-1.11C99.39,110.71,99.29,109.57,98.63,109.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M100.16,114.29l2.18,1.33c-0.2-0.12-0.31-0.36-0.33-0.71c-0.02-0.71,0.43-1.6,1.02-1.97 c0.3-0.2,0.58-0.22,0.78-0.1l-2.18-1.32c-0.2-0.12-0.48-0.1-0.78,0.1c-0.58,0.38-1.04,1.27-1.01,1.98 C99.85,113.93,99.97,114.18,100.16,114.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M104.13,113.55c-0.03-0.72-0.52-0.99-1.11-0.62c-0.58,0.38-1.04,1.27-1.02,1.97 c0.03,0.72,0.52,1,1.11,0.62C103.71,115.14,104.16,114.26,104.13,113.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.2,106.92l11.15,6.75c-0.43-0.27-0.71-0.81-0.73-1.6c-0.07-1.61,0.94-3.61,2.26-4.47 c0.69-0.44,1.31-0.48,1.77-0.2l-11.17-6.77c-0.46-0.28-1.1-0.21-1.77,0.23c-1.32,0.83-2.32,2.84-2.25,4.46 C83.48,106.11,83.76,106.65,84.2,106.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M88.03,102.38c-0.07-1.49-1.11-2.07-2.34-1.28c-1.22,0.77-2.15,2.64-2.09,4.13 c0.08,1.5,1.12,2.09,2.34,1.3C87.16,105.73,88.09,103.87,88.03,102.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M87.84,102.91c-0.05-1.15-0.85-1.59-1.79-0.99c-0.94,0.6-1.65,2.03-1.61,3.16c0.06,1.16,0.86,1.61,1.79,1 C87.18,105.48,87.88,104.05,87.84,102.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M95.65,105.6c-0.44-0.26-1.05-0.22-1.71,0.2c-0.62,0.4-1.18,1.09-1.58,1.85l-5.18-3.11 c0.4-0.78,0.96-1.46,1.59-1.87c0.66-0.43,1.26-0.48,1.71-0.21L95.65,105.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.72,117.17c1.04,0.59,2.4,0.75,3.38,0.4c-0.34,0.12-0.65,0.11-0.9-0.03c-0.31-0.2-0.52-0.6-0.53-1.16 c-0.06-1.17,0.67-2.61,1.63-3.23c0.48-0.31,0.93-0.35,1.26-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.29-1.35-1.26-2.39-2.05-2.9 c-0.47-0.29-1.1-0.25-1.78,0.19c-1.31,0.86-2.32,2.86-2.24,4.47C89.01,116.36,89.29,116.9,89.72,117.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.06,113.82c0.1,0.3,0.47,0.89,0.91,1.2c-0.2-0.12-0.48-0.1-0.78,0.1c-0.58,0.38-1.03,1.27-1,1.98 c0.02,0.34,0.14,0.59,0.32,0.71c-0.09-0.05-0.22-0.1-0.33-0.15c-0.34-0.1-0.76-0.14-1.09-0.08c-0.34,0.12-0.65,0.11-0.9-0.03 c-0.31-0.2-0.52-0.6-0.53-1.16c-0.06-1.17,0.67-2.61,1.63-3.23c0.48-0.31,0.93-0.35,1.26-0.15 C94.81,113.15,94.99,113.44,95.06,113.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.99,112.68c-0.66-0.4-1.61,0.1-2.13,1.11c-0.52,1.01-0.41,2.14,0.25,2.54 c0.65,0.39,1.61-0.1,2.13-1.11C93.75,114.21,93.64,113.07,92.99,112.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M94.53,117.8l2.18,1.33c-0.2-0.12-0.32-0.36-0.33-0.71c-0.02-0.71,0.43-1.6,1.01-1.97 c0.3-0.2,0.58-0.22,0.78-0.1l-2.18-1.32c-0.2-0.12-0.48-0.1-0.78,0.1c-0.58,0.38-1.03,1.27-1,1.98 C94.22,117.43,94.34,117.68,94.53,117.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M98.49,117.05c-0.03-0.72-0.52-0.99-1.11-0.62c-0.58,0.38-1.03,1.27-1.01,1.97 c0.03,0.72,0.52,1,1.11,0.62C98.07,118.65,98.52,117.76,98.49,117.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.57,110.42l11.15,6.75c-0.43-0.27-0.71-0.81-0.74-1.6c-0.08-1.61,0.93-3.61,2.24-4.47 c0.68-0.44,1.31-0.48,1.76-0.2l-11.17-6.77c-0.46-0.28-1.1-0.21-1.77,0.23c-1.31,0.83-2.31,2.84-2.23,4.46 C77.85,109.61,78.14,110.15,78.57,110.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M82.38,105.88c-0.07-1.49-1.11-2.07-2.33-1.28c-1.21,0.77-2.14,2.64-2.08,4.13 c0.09,1.5,1.12,2.09,2.34,1.3C81.53,109.23,82.44,107.37,82.38,105.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M82.19,106.41c-0.05-1.15-0.86-1.59-1.79-0.99c-0.93,0.6-1.64,2.03-1.59,3.16c0.06,1.16,0.86,1.61,1.79,1 C81.54,108.98,82.24,107.55,82.19,106.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M90,109.1c-0.44-0.26-1.05-0.22-1.7,0.2c-0.62,0.4-1.18,1.09-1.57,1.85l-5.18-3.11 c0.4-0.78,0.96-1.46,1.58-1.87c0.66-0.43,1.26-0.48,1.71-0.21L90,109.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.6326,
    y1: 89.5852,
    x2: 106.4714,
    y2: 113.6717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2ECF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    style: {
      stopColor: "#D6EEF9",
      stopOpacity: 0.7115
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6032,
    style: {
      stopColor: "#E4F3FB",
      stopOpacity: 0.3968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#F9FDFE",
      stopOpacity: 0.0707
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "120.1,100.6 87.44,120.65 87.03,103.96 119.98,83.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.6982,
    y1: 119.1872,
    x2: 96.8498,
    y2: 93.5752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2956,
    style: {
      stopColor: "#C3926B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#D19B72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9522,
    style: {
      stopColor: "#E6AA7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAAD7E"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "69.62,98.82 107.45,75.61 125.15,86.26 87.32,109.47  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "69.62,98.82 69.68,100.91 87.37,111.56 87.32,109.47  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "125.15,86.26 125.16,88.35 87.37,111.56 87.32,109.47  "
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.32,109.47c5.97-4.36,12.17-8.34,18.45-12.23c6.33-3.85,12.74-7.61,19.38-10.99 c-6.1,4.36-12.38,8.33-18.68,12.22C100.16,102.33,93.83,106.09,87.32,109.47z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "119.3,91.91 119.29,89.82 101.59,79.17  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "113.86,95.23 113.84,93.14 96.14,82.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "108.44,98.55 108.41,96.46 90.71,85.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "103.03,101.87 103,99.78 85.3,89.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "97.65,105.19 97.61,103.1 79.91,92.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "92.28,108.51 92.24,106.42 74.54,95.77  "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.17,86.51c1.05,0.6,2.43,0.75,3.43,0.4c-0.34,0.12-0.66,0.11-0.91-0.03c-0.31-0.2-0.52-0.6-0.53-1.16 c-0.04-1.17,0.71-2.61,1.69-3.23c0.5-0.31,0.95-0.35,1.29-0.15c0.25,0.15,0.42,0.43,0.49,0.81c-0.28-1.35-1.25-2.39-2.05-2.91 c-0.48-0.29-1.11-0.25-1.81,0.19c-1.34,0.86-2.39,2.85-2.33,4.46C111.46,85.69,111.74,86.24,112.17,86.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.64,83.15c0.1,0.3,0.46,0.89,0.91,1.2c-0.21-0.12-0.49-0.1-0.79,0.09c-0.6,0.38-1.06,1.27-1.04,1.98 c0.01,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.22-0.1-0.33-0.15c-0.35-0.1-0.77-0.14-1.11-0.08c-0.34,0.12-0.66,0.11-0.91-0.03 c-0.31-0.2-0.52-0.6-0.53-1.16c-0.04-1.17,0.71-2.61,1.69-3.23c0.5-0.31,0.95-0.35,1.29-0.15 C117.39,82.49,117.57,82.78,117.64,83.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115.54,82.01c-0.66-0.4-1.64,0.1-2.18,1.11c-0.54,1.01-0.44,2.14,0.22,2.54c0.66,0.39,1.63-0.1,2.17-1.1 C116.3,83.55,116.21,82.41,115.54,82.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M117.04,87.13l2.21,1.33c-0.2-0.12-0.32-0.36-0.33-0.71c-0.02-0.71,0.45-1.6,1.05-1.97 c0.31-0.19,0.59-0.22,0.79-0.1l-2.2-1.32c-0.21-0.12-0.49-0.1-0.79,0.09c-0.6,0.38-1.06,1.27-1.04,1.98 C116.74,86.77,116.86,87.02,117.04,87.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M121.09,86.39c-0.03-0.72-0.52-0.99-1.12-0.62c-0.6,0.38-1.06,1.27-1.05,1.97c0.02,0.72,0.52,1,1.12,0.62 C120.64,87.98,121.1,87.1,121.09,86.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.93,79.75l11.25,6.76c-0.43-0.27-0.71-0.81-0.73-1.6c-0.06-1.61,0.99-3.61,2.33-4.46 c0.7-0.43,1.34-0.48,1.79-0.2l-11.27-6.77c-0.47-0.28-1.12-0.21-1.8,0.23c-1.34,0.83-2.38,2.84-2.32,4.46 C100.2,78.94,100.49,79.49,100.93,79.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M104.85,75.22c-0.05-1.49-1.1-2.07-2.36-1.28c-1.24,0.77-2.21,2.64-2.16,4.13 c0.07,1.5,1.11,2.09,2.37,1.3C103.94,78.57,104.9,76.71,104.85,75.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M104.66,75.75c-0.04-1.15-0.85-1.59-1.81-0.99c-0.96,0.6-1.69,2.03-1.66,3.16c0.05,1.16,0.85,1.61,1.81,1 C103.96,78.32,104.69,76.89,104.66,75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M112.55,78.44c-0.44-0.26-1.06-0.22-1.73,0.2c-0.64,0.4-1.21,1.09-1.62,1.85l-5.22-3.11 c0.41-0.78,0.99-1.46,1.63-1.87c0.67-0.43,1.29-0.48,1.74-0.21L112.55,78.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.43,90.01c1.05,0.59,2.43,0.75,3.43,0.4c-0.34,0.12-0.66,0.12-0.91-0.03c-0.31-0.2-0.52-0.6-0.53-1.16 c-0.05-1.17,0.71-2.61,1.68-3.23c0.5-0.31,0.95-0.35,1.29-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.29-1.35-1.26-2.39-2.06-2.9 c-0.47-0.3-1.11-0.25-1.81,0.19c-1.34,0.86-2.38,2.85-2.31,4.46C105.72,89.19,106,89.74,106.43,90.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111.88,86.65c0.1,0.31,0.47,0.89,0.91,1.2c-0.2-0.12-0.49-0.1-0.79,0.09c-0.59,0.38-1.05,1.27-1.03,1.98 c0.01,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.22-0.1-0.33-0.15c-0.34-0.1-0.77-0.14-1.11-0.08c-0.34,0.12-0.66,0.12-0.91-0.03 c-0.31-0.2-0.52-0.6-0.53-1.16c-0.05-1.17,0.71-2.61,1.68-3.23c0.5-0.31,0.95-0.35,1.29-0.15 C111.63,85.99,111.81,86.27,111.88,86.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.78,85.51c-0.66-0.4-1.63,0.1-2.17,1.11c-0.54,1.01-0.43,2.14,0.23,2.54c0.66,0.39,1.63-0.1,2.17-1.1 C110.55,87.05,110.45,85.91,109.78,85.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M111.3,90.63l2.2,1.33c-0.19-0.12-0.32-0.36-0.33-0.71c-0.02-0.71,0.44-1.6,1.04-1.97 c0.31-0.19,0.59-0.22,0.79-0.1l-2.2-1.32c-0.2-0.12-0.49-0.1-0.79,0.09c-0.59,0.38-1.05,1.27-1.03,1.98 C110.99,90.27,111.11,90.52,111.3,90.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M115.33,89.89c-0.03-0.72-0.52-0.99-1.12-0.62c-0.59,0.38-1.06,1.27-1.04,1.97 c0.03,0.72,0.52,1,1.12,0.62C114.89,91.48,115.35,90.6,115.33,89.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.19,83.25l11.25,6.76c-0.43-0.27-0.71-0.81-0.73-1.6c-0.07-1.61,0.97-3.61,2.31-4.46 c0.7-0.43,1.33-0.48,1.79-0.2l-11.27-6.77c-0.46-0.28-1.11-0.21-1.8,0.23c-1.34,0.83-2.36,2.84-2.3,4.46 C94.46,82.44,94.75,82.99,95.19,83.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M99.09,78.71c-0.06-1.49-1.11-2.07-2.36-1.28c-1.24,0.77-2.19,2.64-2.15,4.13 c0.07,1.5,1.12,2.09,2.36,1.3C98.2,82.07,99.14,80.21,99.09,78.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M98.9,79.25c-0.04-1.15-0.85-1.59-1.81-0.99c-0.95,0.6-1.68,2.03-1.65,3.16c0.05,1.16,0.86,1.61,1.81,1 C98.21,81.82,98.93,80.38,98.9,79.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M106.79,81.94c-0.44-0.26-1.06-0.22-1.73,0.2c-0.63,0.4-1.2,1.09-1.61,1.85l-5.22-3.11 c0.41-0.78,0.98-1.46,1.62-1.87c0.67-0.43,1.28-0.48,1.73-0.21L106.79,81.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.71,93.51c1.05,0.59,2.43,0.75,3.42,0.4c-0.34,0.12-0.66,0.12-0.91-0.03c-0.31-0.2-0.52-0.6-0.53-1.16 c-0.05-1.17,0.7-2.61,1.67-3.23c0.49-0.31,0.94-0.35,1.28-0.15c0.25,0.15,0.42,0.43,0.49,0.81c-0.29-1.35-1.26-2.39-2.06-2.9 c-0.48-0.3-1.11-0.25-1.8,0.19c-1.33,0.86-2.37,2.85-2.3,4.46C100,92.69,100.28,93.24,100.71,93.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.14,90.15c0.1,0.3,0.47,0.89,0.92,1.2c-0.2-0.12-0.49-0.1-0.79,0.09c-0.59,0.38-1.05,1.27-1.02,1.98 c0.02,0.34,0.14,0.59,0.32,0.7c-0.09-0.05-0.22-0.1-0.33-0.15c-0.34-0.1-0.77-0.14-1.11-0.08c-0.34,0.12-0.66,0.12-0.91-0.03 c-0.31-0.2-0.52-0.6-0.53-1.16c-0.05-1.17,0.7-2.61,1.67-3.23c0.49-0.31,0.94-0.35,1.28-0.15 C105.89,89.49,106.07,89.77,106.14,90.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104.04,89.01c-0.66-0.4-1.63,0.1-2.16,1.11c-0.53,1.01-0.43,2.14,0.24,2.54c0.66,0.39,1.63-0.1,2.16-1.1 C104.81,90.55,104.71,89.41,104.04,89.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M105.57,94.13l2.2,1.33c-0.2-0.12-0.32-0.36-0.33-0.71c-0.02-0.71,0.44-1.6,1.03-1.97 c0.31-0.19,0.59-0.22,0.79-0.1l-2.2-1.32c-0.2-0.12-0.49-0.1-0.79,0.09c-0.59,0.38-1.05,1.27-1.02,1.98 C105.27,93.77,105.39,94.02,105.57,94.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M109.59,93.39c-0.03-0.72-0.52-0.99-1.12-0.62c-0.59,0.38-1.05,1.27-1.03,1.97 c0.03,0.72,0.53,1,1.12,0.62C109.16,94.98,109.61,94.09,109.59,93.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.47,86.75l11.25,6.76c-0.43-0.27-0.71-0.81-0.74-1.6c-0.07-1.61,0.96-3.61,2.3-4.46 c0.69-0.44,1.33-0.48,1.78-0.2l-11.27-6.77c-0.47-0.28-1.12-0.21-1.79,0.23c-1.33,0.83-2.35,2.84-2.29,4.46 C88.74,85.94,89.03,86.49,89.47,86.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M93.35,82.21c-0.06-1.49-1.11-2.07-2.35-1.28c-1.23,0.77-2.18,2.64-2.13,4.13 c0.08,1.5,1.12,2.09,2.36,1.3C92.47,85.57,93.4,83.71,93.35,82.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M93.16,82.75c-0.05-1.15-0.86-1.59-1.81-0.99c-0.95,0.6-1.67,2.03-1.63,3.16c0.06,1.16,0.86,1.61,1.81,1 C92.48,85.32,93.2,83.88,93.16,82.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M101.04,85.44c-0.44-0.26-1.06-0.22-1.73,0.21c-0.63,0.4-1.2,1.09-1.6,1.85l-5.22-3.11 c0.41-0.78,0.98-1.46,1.61-1.87c0.67-0.43,1.28-0.48,1.73-0.21L101.04,85.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.02,97.01c1.05,0.59,2.42,0.75,3.42,0.4c-0.34,0.12-0.65,0.12-0.9-0.03c-0.31-0.2-0.52-0.6-0.53-1.16 c-0.05-1.17,0.69-2.61,1.65-3.23c0.49-0.31,0.94-0.35,1.28-0.15c0.24,0.15,0.42,0.43,0.49,0.81c-0.3-1.35-1.26-2.39-2.07-2.9 c-0.47-0.3-1.1-0.25-1.8,0.19c-1.33,0.86-2.35,2.85-2.28,4.46C94.3,96.19,94.58,96.74,95.02,97.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.42,93.65c0.1,0.3,0.47,0.89,0.92,1.2c-0.2-0.12-0.48-0.1-0.78,0.09c-0.59,0.38-1.05,1.27-1.02,1.98 c0.02,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.33-0.15c-0.34-0.1-0.77-0.14-1.11-0.08c-0.34,0.12-0.65,0.12-0.9-0.03 c-0.31-0.2-0.52-0.6-0.53-1.16c-0.05-1.17,0.69-2.61,1.65-3.23c0.49-0.31,0.94-0.35,1.28-0.15 C100.17,92.99,100.35,93.27,100.42,93.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M98.33,92.51c-0.66-0.4-1.63,0.1-2.16,1.11c-0.53,1.01-0.42,2.14,0.24,2.54c0.66,0.39,1.62-0.1,2.15-1.1 C99.1,94.05,98.99,92.91,98.33,92.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.87,97.63l2.2,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.43-1.6,1.02-1.97 c0.31-0.19,0.58-0.22,0.78-0.1l-2.2-1.32c-0.2-0.12-0.48-0.1-0.78,0.09c-0.59,0.38-1.05,1.27-1.02,1.98 C99.56,97.27,99.68,97.52,99.87,97.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M103.88,96.89c-0.03-0.72-0.53-0.99-1.12-0.62c-0.59,0.38-1.04,1.27-1.02,1.97 c0.03,0.72,0.53,1,1.12,0.62C103.45,98.48,103.9,97.59,103.88,96.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M83.77,90.25l11.25,6.76c-0.43-0.27-0.72-0.81-0.74-1.6c-0.07-1.61,0.95-3.61,2.28-4.46 c0.7-0.44,1.33-0.48,1.78-0.2l-11.27-6.77c-0.46-0.28-1.11-0.21-1.79,0.23c-1.33,0.83-2.34,2.84-2.27,4.46 C83.04,89.44,83.33,89.99,83.77,90.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M87.63,85.71c-0.07-1.49-1.12-2.07-2.36-1.28c-1.23,0.77-2.17,2.64-2.11,4.13 c0.08,1.5,1.13,2.09,2.36,1.3C86.76,89.07,87.69,87.21,87.63,85.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M87.44,86.25c-0.05-1.15-0.86-1.59-1.81-0.99c-0.94,0.6-1.66,2.03-1.62,3.16c0.06,1.16,0.87,1.61,1.81,1 C86.77,88.82,87.49,87.38,87.44,86.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M95.32,88.94c-0.44-0.26-1.06-0.22-1.72,0.21c-0.63,0.4-1.19,1.09-1.59,1.85l-5.22-3.11 c0.41-0.78,0.97-1.46,1.6-1.87c0.66-0.43,1.27-0.48,1.73-0.21L95.32,88.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.34,100.51c1.05,0.59,2.42,0.75,3.41,0.4c-0.34,0.12-0.66,0.11-0.9-0.03c-0.31-0.2-0.52-0.6-0.54-1.16 c-0.06-1.17,0.68-2.61,1.64-3.23c0.49-0.31,0.94-0.35,1.28-0.15c0.25,0.15,0.43,0.43,0.5,0.81c-0.3-1.35-1.27-2.39-2.07-2.91 c-0.48-0.29-1.11-0.25-1.8,0.19c-1.32,0.86-2.34,2.85-2.26,4.47C88.62,99.7,88.91,100.24,89.34,100.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.73,97.15c0.1,0.3,0.47,0.89,0.92,1.2c-0.2-0.12-0.48-0.1-0.79,0.09c-0.59,0.38-1.04,1.27-1,1.98 c0.02,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.33-0.15c-0.34-0.1-0.77-0.14-1.1-0.08c-0.34,0.12-0.66,0.11-0.9-0.03 c-0.31-0.2-0.52-0.6-0.54-1.16c-0.06-1.17,0.68-2.61,1.64-3.23c0.49-0.31,0.94-0.35,1.28-0.15 C94.47,96.49,94.65,96.77,94.73,97.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.63,96.01c-0.66-0.4-1.62,0.1-2.15,1.11c-0.52,1.01-0.41,2.14,0.25,2.54c0.66,0.39,1.62-0.1,2.15-1.1 C93.41,97.55,93.29,96.41,92.63,96.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M94.18,101.13l2.2,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.43-1.6,1.01-1.97 c0.31-0.19,0.59-0.22,0.79-0.1l-2.2-1.32c-0.2-0.12-0.48-0.1-0.79,0.09c-0.59,0.38-1.04,1.27-1,1.98 C93.88,100.77,94,101.02,94.18,101.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M98.18,100.39c-0.03-0.72-0.53-0.99-1.12-0.62c-0.58,0.38-1.04,1.27-1.01,1.97 c0.03,0.72,0.53,1,1.12,0.62C97.76,101.98,98.21,101.1,98.18,100.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.09,93.75l11.25,6.76c-0.43-0.27-0.71-0.81-0.74-1.6c-0.08-1.61,0.94-3.61,2.26-4.47 c0.69-0.44,1.32-0.48,1.77-0.2l-11.27-6.77c-0.47-0.28-1.11-0.21-1.79,0.23c-1.32,0.83-2.33,2.84-2.25,4.46 C77.37,92.94,77.66,93.49,78.09,93.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M81.94,89.21c-0.07-1.49-1.12-2.07-2.35-1.28c-1.23,0.77-2.16,2.64-2.1,4.13c0.09,1.5,1.13,2.09,2.36,1.3 C81.08,92.57,82,90.71,81.94,89.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M81.75,89.75c-0.05-1.15-0.86-1.59-1.81-0.99c-0.94,0.6-1.65,2.03-1.61,3.16c0.06,1.16,0.87,1.61,1.81,1 C81.09,92.32,81.79,90.88,81.75,89.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M89.62,92.44c-0.44-0.26-1.06-0.22-1.72,0.21c-0.62,0.4-1.19,1.09-1.58,1.85l-5.22-3.11 c0.4-0.78,0.97-1.46,1.59-1.87c0.66-0.43,1.27-0.48,1.72-0.21L89.62,92.44z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.3691,
    y1: 72.1558,
    x2: 106.1919,
    y2: 96.1761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2ECF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    style: {
      stopColor: "#D6EEF9",
      stopOpacity: 0.7115
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6032,
    style: {
      stopColor: "#E4F3FB",
      stopOpacity: 0.3968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#F9FDFE",
      stopOpacity: 0.0707
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "119.98,83.14 87.02,103.19 86.61,86.49 119.86,66.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.3428,
    y1: 101.7771,
    x2: 96.5215,
    y2: 76.1123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2956,
    style: {
      stopColor: "#C3926B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#D19B72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9522,
    style: {
      stopColor: "#E6AA7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAAD7E"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "69.04,81.35 107.22,58.14 125.07,68.8 86.9,92  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "69.04,81.35 69.11,83.44 86.95,94.1 86.9,92  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "125.07,68.8 125.08,70.89 86.95,94.1 86.9,92  "
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M86.9,92c6.02-4.35,12.28-8.33,18.62-12.22c6.39-3.85,12.85-7.61,19.55-10.98 c-6.15,4.35-12.49,8.33-18.85,12.22C99.86,84.86,93.47,88.62,86.9,92z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "119.17,74.45 119.16,72.36 101.3,61.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "113.68,77.77 113.66,75.67 95.81,65.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "108.21,81.09 108.18,78.99 90.33,68.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "102.76,84.41 102.72,82.31 84.87,71.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "97.32,87.73 97.28,85.63 79.43,74.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "91.91,91.05 91.86,88.95 74.01,78.3  "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111.97,68.14c1.06,0.6,2.45,0.75,3.47,0.4c-0.35,0.12-0.67,0.12-0.92-0.03c-0.31-0.2-0.52-0.6-0.53-1.16 c-0.04-1.17,0.72-2.61,1.71-3.22c0.5-0.31,0.96-0.35,1.3-0.15c0.25,0.15,0.43,0.43,0.49,0.81c-0.28-1.35-1.26-2.39-2.07-2.91 c-0.48-0.29-1.12-0.25-1.83,0.19c-1.36,0.86-2.41,2.85-2.35,4.46C111.25,67.32,111.54,67.87,111.97,68.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.49,64.78c0.1,0.3,0.47,0.89,0.92,1.2c-0.21-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.07,1.27-1.05,1.98 c0.01,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.22-0.1-0.33-0.15c-0.35-0.1-0.78-0.14-1.12-0.08c-0.35,0.12-0.67,0.12-0.92-0.03 c-0.31-0.2-0.52-0.6-0.53-1.16c-0.04-1.17,0.72-2.61,1.71-3.22c0.5-0.31,0.96-0.35,1.3-0.15 C117.24,64.12,117.42,64.4,117.49,64.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115.37,63.64c-0.67-0.4-1.65,0.1-2.2,1.1c-0.54,1.01-0.45,2.14,0.22,2.54c0.66,0.39,1.64-0.1,2.19-1.1 C116.14,65.18,116.04,64.04,115.37,63.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M116.89,68.76l2.23,1.33c-0.2-0.12-0.32-0.36-0.33-0.71c-0.02-0.71,0.45-1.6,1.06-1.97 c0.31-0.19,0.6-0.22,0.8-0.1l-2.22-1.32c-0.21-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.07,1.27-1.05,1.98 C116.58,68.4,116.7,68.65,116.89,68.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M120.97,68.02c-0.03-0.72-0.53-0.99-1.13-0.62c-0.6,0.38-1.07,1.27-1.06,1.97c0.02,0.72,0.53,1,1.13,0.62 C120.52,69.61,120.98,68.73,120.97,68.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.62,61.38l11.35,6.76c-0.43-0.27-0.72-0.81-0.74-1.6c-0.06-1.61,1-3.61,2.35-4.46 c0.71-0.44,1.35-0.48,1.81-0.2l-11.37-6.77c-0.47-0.28-1.13-0.21-1.82,0.23c-1.35,0.83-2.4,2.84-2.35,4.46 C99.89,60.57,100.18,61.11,100.62,61.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M104.58,56.84c-0.05-1.49-1.11-2.07-2.38-1.29c-1.26,0.77-2.23,2.64-2.19,4.13 c0.07,1.5,1.13,2.09,2.39,1.3C103.67,60.19,104.63,58.34,104.58,56.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M104.38,57.37c-0.04-1.15-0.86-1.59-1.82-0.99c-0.96,0.6-1.71,2.03-1.67,3.16c0.05,1.16,0.86,1.61,1.83,1 C103.68,59.94,104.42,58.51,104.38,57.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M112.36,60.07c-0.45-0.26-1.07-0.22-1.75,0.2c-0.64,0.4-1.22,1.09-1.63,1.85l-5.27-3.11 c0.42-0.78,1-1.46,1.64-1.87c0.68-0.43,1.3-0.48,1.75-0.21L112.36,60.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.18,71.63c1.06,0.6,2.45,0.75,3.46,0.4c-0.35,0.12-0.66,0.11-0.92-0.03c-0.31-0.2-0.52-0.6-0.53-1.16 c-0.05-1.17,0.71-2.61,1.69-3.23c0.5-0.31,0.96-0.35,1.3-0.15c0.25,0.15,0.43,0.43,0.5,0.81c-0.29-1.35-1.27-2.39-2.08-2.91 c-0.48-0.29-1.12-0.25-1.82,0.19c-1.35,0.86-2.4,2.85-2.33,4.46C105.46,70.82,105.74,71.36,106.18,71.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111.68,68.28c0.1,0.3,0.47,0.89,0.92,1.2c-0.2-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.07,1.27-1.04,1.98 c0.01,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.34-0.15c-0.35-0.1-0.78-0.14-1.12-0.08c-0.35,0.12-0.66,0.11-0.92-0.03 c-0.31-0.2-0.52-0.6-0.53-1.16c-0.05-1.17,0.71-2.61,1.69-3.23c0.5-0.31,0.96-0.35,1.3-0.15 C111.42,67.62,111.61,67.9,111.68,68.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.56,67.14c-0.67-0.4-1.65,0.1-2.19,1.1c-0.54,1.01-0.44,2.14,0.23,2.54c0.66,0.4,1.64-0.1,2.19-1.1 C110.33,68.67,110.23,67.54,109.56,67.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M111.09,72.26l2.22,1.33c-0.2-0.12-0.32-0.36-0.33-0.71c-0.02-0.71,0.45-1.6,1.05-1.97 c0.31-0.19,0.59-0.22,0.8-0.1l-2.22-1.32c-0.2-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.07,1.27-1.04,1.98 C110.78,71.9,110.9,72.15,111.09,72.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M115.15,71.52c-0.03-0.72-0.53-0.99-1.13-0.62c-0.6,0.38-1.07,1.27-1.05,1.97c0.03,0.72,0.53,1,1.13,0.62 C114.71,73.11,115.17,72.22,115.15,71.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.82,64.88l11.35,6.76c-0.44-0.27-0.72-0.81-0.74-1.6c-0.07-1.61,0.98-3.61,2.33-4.46 c0.71-0.44,1.35-0.48,1.81-0.2L98.2,58.6c-0.47-0.28-1.12-0.21-1.82,0.23c-1.35,0.83-2.39,2.84-2.33,4.46 C94.09,64.06,94.38,64.61,94.82,64.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M98.77,60.34c-0.06-1.49-1.12-2.07-2.38-1.28c-1.25,0.77-2.21,2.64-2.17,4.12 c0.07,1.5,1.13,2.09,2.38,1.3C97.86,63.69,98.82,61.83,98.77,60.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M98.57,60.87c-0.04-1.15-0.86-1.59-1.82-0.99c-0.96,0.6-1.7,2.03-1.66,3.16c0.05,1.16,0.87,1.61,1.83,1 C97.88,63.44,98.61,62.01,98.57,60.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M106.53,63.56c-0.45-0.26-1.07-0.22-1.75,0.2c-0.64,0.4-1.21,1.09-1.62,1.85l-5.27-3.11 c0.42-0.78,0.99-1.46,1.64-1.87c0.67-0.43,1.29-0.48,1.75-0.21L106.53,63.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.4,75.13c1.06,0.6,2.45,0.75,3.46,0.4c-0.34,0.12-0.66,0.11-0.91-0.03c-0.31-0.2-0.52-0.6-0.54-1.16 c-0.05-1.17,0.7-2.61,1.68-3.23c0.5-0.31,0.95-0.35,1.29-0.15c0.25,0.15,0.43,0.43,0.5,0.81c-0.29-1.35-1.27-2.39-2.08-2.91 c-0.48-0.29-1.12-0.25-1.82,0.19c-1.35,0.86-2.39,2.85-2.32,4.46C99.68,74.32,99.97,74.86,100.4,75.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105.88,71.78c0.1,0.3,0.47,0.89,0.93,1.2c-0.2-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.06,1.27-1.03,1.98 c0.02,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.34-0.15c-0.35-0.1-0.78-0.14-1.12-0.08c-0.34,0.12-0.66,0.11-0.91-0.03 c-0.31-0.2-0.52-0.6-0.54-1.16c-0.05-1.17,0.7-2.61,1.68-3.23c0.5-0.31,0.95-0.35,1.29-0.15 C105.63,71.12,105.81,71.4,105.88,71.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M103.77,70.64c-0.67-0.4-1.64,0.1-2.18,1.1c-0.54,1.01-0.43,2.14,0.24,2.54c0.66,0.39,1.64-0.1,2.18-1.1 C104.54,72.17,104.43,71.03,103.77,70.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M105.31,75.76l2.22,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.44-1.6,1.04-1.97 c0.31-0.19,0.59-0.22,0.8-0.1l-2.22-1.32c-0.2-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.06,1.27-1.03,1.98 C105,75.4,105.12,75.64,105.31,75.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M109.37,75.02c-0.03-0.72-0.53-0.99-1.13-0.62c-0.59,0.38-1.06,1.27-1.04,1.97 c0.03,0.72,0.53,1,1.13,0.62C108.93,76.61,109.38,75.72,109.37,75.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.05,68.37l11.35,6.76c-0.43-0.27-0.72-0.81-0.74-1.6c-0.07-1.61,0.97-3.61,2.32-4.46 c0.7-0.44,1.34-0.48,1.8-0.2L92.4,62.09c-0.47-0.28-1.13-0.21-1.81,0.23c-1.34,0.83-2.38,2.84-2.31,4.46 C88.32,67.56,88.61,68.11,89.05,68.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M92.97,63.84c-0.06-1.49-1.12-2.07-2.38-1.28c-1.25,0.77-2.2,2.64-2.15,4.13c0.08,1.5,1.13,2.09,2.39,1.3 C92.08,67.19,93.03,65.33,92.97,63.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92.78,64.37c-0.05-1.15-0.86-1.59-1.82-0.99c-0.96,0.6-1.69,2.03-1.65,3.16c0.06,1.16,0.87,1.61,1.83,1 C92.09,66.94,92.82,65.51,92.78,64.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M100.74,67.06c-0.45-0.26-1.07-0.22-1.74,0.2c-0.64,0.4-1.21,1.09-1.61,1.85l-5.27-3.11 c0.41-0.78,0.99-1.46,1.63-1.87c0.67-0.43,1.29-0.48,1.75-0.21L100.74,67.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.65,78.63c1.06,0.6,2.45,0.75,3.45,0.4c-0.34,0.12-0.66,0.11-0.91-0.03c-0.31-0.2-0.52-0.6-0.54-1.16 c-0.05-1.17,0.69-2.61,1.67-3.23c0.5-0.31,0.95-0.35,1.29-0.15c0.25,0.15,0.43,0.43,0.5,0.81c-0.3-1.35-1.28-2.39-2.09-2.91 c-0.48-0.29-1.12-0.25-1.82,0.19c-1.34,0.86-2.37,2.85-2.3,4.46C93.93,77.82,94.21,78.36,94.65,78.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.11,75.28c0.1,0.3,0.47,0.89,0.93,1.2c-0.2-0.12-0.49-0.1-0.79,0.09c-0.6,0.38-1.06,1.27-1.03,1.98 c0.02,0.34,0.14,0.59,0.33,0.71c-0.09-0.05-0.22-0.1-0.34-0.15c-0.34-0.1-0.78-0.14-1.12-0.08c-0.34,0.12-0.66,0.11-0.91-0.03 c-0.31-0.2-0.52-0.6-0.54-1.16c-0.05-1.17,0.69-2.61,1.67-3.23c0.5-0.31,0.95-0.35,1.29-0.15 C99.85,74.62,100.04,74.9,100.11,75.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.99,74.14c-0.67-0.4-1.64,0.1-2.18,1.11c-0.53,1.01-0.42,2.14,0.24,2.54c0.66,0.39,1.64-0.1,2.17-1.1 C98.77,75.67,98.66,74.53,97.99,74.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.55,79.26l2.22,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.44-1.6,1.03-1.97 c0.31-0.19,0.59-0.22,0.79-0.1l-2.22-1.32c-0.2-0.12-0.49-0.1-0.79,0.09c-0.6,0.38-1.06,1.27-1.03,1.98 C99.23,78.9,99.36,79.14,99.55,79.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M103.59,78.51c-0.03-0.72-0.53-0.99-1.13-0.62c-0.6,0.38-1.05,1.27-1.03,1.97c0.03,0.72,0.53,1,1.13,0.62 C103.16,80.11,103.62,79.22,103.59,78.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M83.3,71.87l11.35,6.76c-0.44-0.27-0.72-0.81-0.75-1.6c-0.08-1.61,0.96-3.61,2.3-4.46 c0.7-0.44,1.34-0.48,1.8-0.2l-11.38-6.77c-0.47-0.28-1.12-0.21-1.81,0.23c-1.34,0.83-2.36,2.84-2.29,4.46 C82.56,71.06,82.86,71.61,83.3,71.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M87.2,67.34c-0.07-1.49-1.13-2.07-2.38-1.28c-1.24,0.77-2.19,2.64-2.13,4.13c0.08,1.5,1.14,2.09,2.38,1.3 C86.32,70.69,87.26,68.83,87.2,67.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M87.01,67.87c-0.05-1.15-0.87-1.59-1.82-0.99c-0.95,0.6-1.68,2.03-1.64,3.16c0.06,1.16,0.87,1.61,1.83,1 C86.33,70.44,87.05,69.01,87.01,67.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M94.96,70.56c-0.45-0.26-1.07-0.22-1.74,0.2c-0.63,0.4-1.2,1.09-1.61,1.85l-5.27-3.11 c0.41-0.78,0.98-1.46,1.62-1.87c0.67-0.43,1.29-0.48,1.74-0.21L94.96,70.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.92,82.13c1.06,0.6,2.44,0.75,3.45,0.4c-0.34,0.12-0.66,0.11-0.91-0.03c-0.32-0.2-0.53-0.6-0.54-1.16 c-0.06-1.17,0.69-2.61,1.66-3.23c0.49-0.31,0.95-0.35,1.29-0.15c0.25,0.15,0.43,0.43,0.5,0.81c-0.3-1.36-1.28-2.39-2.09-2.91 c-0.48-0.29-1.12-0.25-1.81,0.19c-1.34,0.86-2.36,2.85-2.28,4.46C88.2,81.32,88.48,81.86,88.92,82.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.36,78.78c0.1,0.3,0.48,0.89,0.93,1.2c-0.2-0.12-0.49-0.1-0.79,0.09c-0.59,0.38-1.05,1.27-1.01,1.98 c0.02,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.33-0.15c-0.35-0.1-0.78-0.14-1.11-0.08c-0.34,0.12-0.66,0.11-0.91-0.03 c-0.32-0.2-0.53-0.6-0.54-1.16c-0.06-1.17,0.69-2.61,1.66-3.23c0.49-0.31,0.95-0.35,1.29-0.15 C94.1,78.12,94.28,78.4,94.36,78.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.24,77.64c-0.67-0.4-1.64,0.1-2.17,1.11c-0.53,1.01-0.41,2.14,0.25,2.54c0.66,0.39,1.63-0.1,2.17-1.1 C93.02,79.17,92.91,78.03,92.24,77.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M93.81,82.76l2.22,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.43-1.6,1.02-1.97 c0.31-0.19,0.59-0.22,0.79-0.1l-2.22-1.32c-0.2-0.12-0.49-0.1-0.79,0.09c-0.59,0.38-1.05,1.27-1.01,1.98 C93.5,82.4,93.62,82.64,93.81,82.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M97.85,82.01c-0.03-0.72-0.53-0.99-1.13-0.62c-0.59,0.38-1.05,1.27-1.02,1.97c0.03,0.72,0.53,1,1.13,0.62 C97.42,83.61,97.87,82.72,97.85,82.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.56,75.37l11.35,6.76c-0.43-0.27-0.72-0.81-0.75-1.6c-0.08-1.61,0.95-3.61,2.28-4.46 c0.7-0.44,1.33-0.48,1.79-0.2l-11.37-6.77c-0.47-0.28-1.12-0.21-1.8,0.23c-1.33,0.83-2.35,2.84-2.28,4.46 C76.83,74.56,77.12,75.11,77.56,75.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M81.45,70.84c-0.07-1.49-1.13-2.07-2.38-1.28c-1.24,0.77-2.18,2.64-2.12,4.13 c0.09,1.5,1.14,2.09,2.39,1.3C80.58,74.19,81.51,72.33,81.45,70.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M81.25,71.37c-0.05-1.15-0.87-1.59-1.82-0.99c-0.95,0.6-1.67,2.03-1.62,3.16c0.06,1.16,0.87,1.61,1.83,1 C80.59,73.94,81.3,72.5,81.25,71.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M89.2,74.06c-0.45-0.26-1.07-0.22-1.73,0.2c-0.63,0.4-1.2,1.09-1.6,1.85L80.6,73 c0.41-0.78,0.98-1.46,1.61-1.87c0.67-0.43,1.28-0.48,1.74-0.21L89.2,74.06z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.1057,
    y1: 54.7273,
    x2: 105.9122,
    y2: 78.6806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2ECF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    style: {
      stopColor: "#D6EEF9",
      stopOpacity: 0.7115
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6032,
    style: {
      stopColor: "#E4F3FB",
      stopOpacity: 0.3968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#F9FDFE",
      stopOpacity: 0.0707
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "119.86,65.68 86.59,85.72 86.19,69.03 119.74,48.99  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.9873,
    y1: 84.3674,
    x2: 96.1934,
    y2: 58.6491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2956,
    style: {
      stopColor: "#C3926B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#D19B72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9522,
    style: {
      stopColor: "#E6AA7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAAD7E"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "68.46,63.87 106.98,40.68 125,51.34 86.47,74.54  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "68.46,63.87 68.53,65.97 86.53,76.63 86.47,74.54  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "125,51.34 125.01,53.43 86.53,76.63 86.47,74.54  "
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M86.47,74.54c6.08-4.35,12.4-8.33,18.79-12.22c6.44-3.85,12.97-7.6,19.73-10.98 c-6.21,4.35-12.6,8.33-19.02,12.21C99.55,67.4,93.11,71.15,86.47,74.54z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "119.05,56.99 119.03,54.9 101.02,44.24  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "113.5,60.31 113.48,58.21 95.47,47.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "107.98,63.62 107.96,61.53 89.94,50.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "102.48,66.94 102.45,64.85 84.43,54.19  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "97,70.26 96.96,68.17 78.94,57.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "91.53,73.58 91.49,71.49 73.47,60.83  "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M111.77,50.45c1.07,0.6,2.47,0.75,3.5,0.4c-0.35,0.12-0.67,0.11-0.93-0.03c-0.32-0.2-0.53-0.6-0.54-1.16 c-0.04-1.17,0.73-2.61,1.73-3.22c0.51-0.31,0.97-0.35,1.31-0.15c0.25,0.15,0.43,0.43,0.5,0.81c-0.29-1.35-1.27-2.39-2.09-2.91 c-0.48-0.29-1.13-0.25-1.84,0.19c-1.37,0.86-2.44,2.85-2.38,4.46C111.05,49.64,111.34,50.18,111.77,50.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M117.35,47.1c0.1,0.3,0.47,0.89,0.93,1.2c-0.21-0.12-0.5-0.1-0.8,0.09c-0.61,0.38-1.08,1.27-1.06,1.98 c0.01,0.34,0.13,0.59,0.32,0.7c-0.09-0.05-0.22-0.1-0.34-0.15c-0.35-0.1-0.79-0.14-1.13-0.08c-0.35,0.12-0.67,0.11-0.93-0.03 c-0.32-0.2-0.53-0.6-0.54-1.16c-0.04-1.17,0.73-2.61,1.73-3.22c0.51-0.31,0.97-0.35,1.31-0.15 C117.09,46.44,117.27,46.72,117.35,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M115.21,45.96c-0.67-0.4-1.67,0.1-2.22,1.1c-0.55,1.01-0.45,2.14,0.23,2.54c0.67,0.39,1.66-0.1,2.21-1.1 C115.98,47.49,115.88,46.36,115.21,45.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M116.74,51.08l2.25,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.46-1.6,1.07-1.97 c0.32-0.19,0.6-0.22,0.81-0.1l-2.24-1.32c-0.21-0.12-0.5-0.1-0.8,0.09c-0.61,0.38-1.08,1.27-1.06,1.98 C116.43,50.72,116.55,50.97,116.74,51.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M120.85,50.34c-0.03-0.72-0.53-0.99-1.14-0.62c-0.61,0.38-1.08,1.27-1.07,1.97c0.02,0.72,0.53,1,1.14,0.62 C120.4,51.93,120.87,51.04,120.85,50.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M100.32,43.69l11.45,6.76c-0.44-0.27-0.72-0.81-0.74-1.6c-0.06-1.61,1.01-3.61,2.38-4.46 c0.71-0.44,1.36-0.48,1.82-0.2l-11.47-6.78c-0.47-0.28-1.14-0.21-1.84,0.23c-1.37,0.83-2.42,2.84-2.37,4.46 C99.58,42.88,99.88,43.43,100.32,43.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M104.32,39.16c-0.05-1.49-1.12-2.07-2.4-1.29c-1.27,0.77-2.25,2.64-2.21,4.12c0.07,1.5,1.13,2.09,2.41,1.3 C103.4,42.51,104.37,40.65,104.32,39.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M104.12,39.69c-0.04-1.15-0.87-1.59-1.84-0.99c-0.97,0.6-1.72,2.03-1.69,3.16c0.05,1.16,0.87,1.61,1.84,1 C103.41,42.26,104.16,40.83,104.12,39.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M112.17,42.38c-0.45-0.26-1.08-0.22-1.76,0.2c-0.65,0.4-1.23,1.08-1.65,1.85l-5.32-3.11 c0.42-0.78,1.01-1.46,1.66-1.87c0.68-0.43,1.31-0.48,1.77-0.21L112.17,42.38z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M105.93,53.95c1.07,0.6,2.47,0.75,3.49,0.4c-0.35,0.12-0.67,0.11-0.92-0.03c-0.32-0.2-0.53-0.6-0.54-1.16 c-0.05-1.17,0.72-2.61,1.71-3.22c0.51-0.31,0.97-0.35,1.31-0.15c0.25,0.15,0.43,0.43,0.5,0.81c-0.29-1.35-1.28-2.39-2.1-2.91 c-0.48-0.29-1.13-0.25-1.84,0.19c-1.36,0.86-2.42,2.85-2.35,4.46C105.2,53.14,105.49,53.68,105.93,53.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M111.48,50.6c0.1,0.3,0.47,0.89,0.93,1.2c-0.21-0.12-0.49-0.1-0.81,0.09c-0.6,0.38-1.07,1.27-1.05,1.98 c0.01,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.34-0.15c-0.35-0.1-0.79-0.14-1.13-0.08c-0.35,0.12-0.67,0.11-0.92-0.03 c-0.32-0.2-0.53-0.6-0.54-1.16c-0.05-1.17,0.72-2.61,1.71-3.22c0.51-0.31,0.97-0.35,1.31-0.15 C111.22,49.94,111.41,50.22,111.48,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M109.34,49.46c-0.67-0.4-1.66,0.1-2.21,1.1c-0.55,1.01-0.44,2.14,0.23,2.54c0.67,0.39,1.66-0.1,2.21-1.1 C110.12,50.99,110.02,49.85,109.34,49.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M110.88,54.58l2.24,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.45-1.6,1.06-1.97 c0.31-0.19,0.6-0.22,0.8-0.1l-2.24-1.32c-0.21-0.12-0.49-0.1-0.81,0.09c-0.6,0.38-1.07,1.27-1.05,1.98 C110.57,54.22,110.69,54.46,110.88,54.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M114.99,53.84c-0.03-0.72-0.53-0.99-1.14-0.62c-0.61,0.38-1.08,1.27-1.06,1.97c0.03,0.72,0.53,1,1.14,0.62 C114.54,55.43,115.01,54.54,114.99,53.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M94.48,47.19l11.45,6.76c-0.44-0.27-0.73-0.81-0.75-1.6c-0.07-1.61,0.99-3.61,2.35-4.46 c0.71-0.44,1.36-0.48,1.82-0.2l-11.48-6.78c-0.47-0.28-1.13-0.21-1.83,0.23c-1.36,0.83-2.41,2.84-2.35,4.46 C93.74,46.38,94.03,46.92,94.48,47.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M98.46,42.65c-0.06-1.49-1.13-2.07-2.4-1.29c-1.26,0.77-2.23,2.64-2.19,4.13c0.07,1.5,1.14,2.09,2.41,1.3 C97.54,46.01,98.5,44.15,98.46,42.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M98.26,43.18c-0.04-1.15-0.87-1.59-1.84-0.99c-0.97,0.6-1.71,2.03-1.68,3.16c0.05,1.16,0.88,1.61,1.84,1 C97.56,45.75,98.29,44.32,98.26,43.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M106.29,45.88c-0.45-0.26-1.08-0.22-1.76,0.2c-0.64,0.4-1.22,1.08-1.64,1.85l-5.32-3.11 c0.42-0.78,1-1.46,1.65-1.87c0.68-0.43,1.3-0.48,1.76-0.21L106.29,45.88z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M100.1,57.45c1.07,0.6,2.47,0.75,3.49,0.4c-0.35,0.12-0.67,0.11-0.92-0.03c-0.32-0.2-0.53-0.6-0.54-1.16 c-0.05-1.17,0.71-2.61,1.7-3.23c0.5-0.31,0.96-0.35,1.31-0.15c0.25,0.15,0.43,0.43,0.5,0.81c-0.29-1.36-1.28-2.39-2.1-2.91 c-0.48-0.29-1.13-0.25-1.84,0.19c-1.36,0.86-2.41,2.85-2.34,4.46C99.38,56.63,99.66,57.18,100.1,57.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M105.63,54.09c0.1,0.3,0.48,0.89,0.94,1.2c-0.21-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.07,1.27-1.04,1.98 c0.02,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.34-0.15c-0.35-0.1-0.78-0.14-1.13-0.08c-0.35,0.12-0.67,0.11-0.92-0.03 c-0.32-0.2-0.53-0.6-0.54-1.16c-0.05-1.17,0.71-2.61,1.7-3.23c0.5-0.31,0.96-0.35,1.31-0.15 C105.38,53.43,105.56,53.72,105.63,54.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M103.5,52.95c-0.67-0.4-1.66,0.1-2.2,1.11c-0.54,1.01-0.44,2.14,0.24,2.54c0.67,0.4,1.66-0.1,2.2-1.1 C104.28,54.49,104.17,53.35,103.5,52.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M105.05,58.07l2.24,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.45-1.6,1.05-1.97 c0.32-0.19,0.6-0.22,0.8-0.1l-2.24-1.32c-0.21-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.07,1.27-1.04,1.98 C104.74,57.71,104.86,57.96,105.05,58.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M109.15,57.33c-0.03-0.72-0.53-0.99-1.14-0.62c-0.6,0.38-1.07,1.27-1.05,1.97c0.03,0.72,0.53,1,1.14,0.62 C108.7,58.93,109.17,58.04,109.15,57.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M88.65,50.69l11.45,6.76c-0.44-0.27-0.72-0.82-0.75-1.6c-0.07-1.61,0.98-3.61,2.34-4.46 c0.71-0.43,1.35-0.48,1.82-0.2l-11.47-6.78c-0.47-0.28-1.14-0.21-1.83,0.23c-1.36,0.83-2.4,2.84-2.33,4.46 C87.91,49.87,88.2,50.42,88.65,50.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M92.61,46.15c-0.06-1.49-1.13-2.07-2.4-1.29c-1.26,0.77-2.22,2.64-2.17,4.13c0.08,1.5,1.14,2.09,2.41,1.3 C91.7,49.5,92.66,47.64,92.61,46.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.41,46.68c-0.05-1.15-0.87-1.59-1.84-0.99c-0.97,0.6-1.7,2.03-1.66,3.16c0.06,1.16,0.88,1.61,1.84,1 C91.72,49.25,92.45,47.82,92.41,46.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M100.44,49.38c-0.45-0.26-1.08-0.22-1.76,0.2c-0.64,0.4-1.22,1.09-1.63,1.85l-5.32-3.11 c0.42-0.78,1-1.46,1.64-1.87c0.68-0.43,1.3-0.48,1.76-0.21L100.44,49.38z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M94.3,60.95c1.07,0.6,2.47,0.75,3.48,0.4c-0.35,0.12-0.67,0.12-0.92-0.03c-0.32-0.2-0.53-0.6-0.54-1.16 c-0.05-1.17,0.7-2.61,1.69-3.23c0.5-0.31,0.96-0.35,1.3-0.14c0.25,0.15,0.43,0.43,0.5,0.81c-0.3-1.36-1.29-2.39-2.11-2.91 c-0.48-0.3-1.13-0.25-1.83,0.19c-1.35,0.86-2.4,2.85-2.32,4.46C93.57,60.13,93.86,60.67,94.3,60.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M99.81,57.59c0.1,0.31,0.48,0.89,0.93,1.2c-0.21-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.07,1.27-1.03,1.98 c0.02,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.34-0.15c-0.35-0.1-0.78-0.14-1.13-0.08c-0.35,0.12-0.67,0.12-0.92-0.03 c-0.32-0.2-0.53-0.6-0.54-1.16c-0.05-1.17,0.7-2.61,1.69-3.23c0.5-0.31,0.96-0.35,1.3-0.14C99.55,56.93,99.73,57.21,99.81,57.59 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M97.67,56.45c-0.67-0.4-1.66,0.1-2.2,1.11c-0.54,1.01-0.43,2.14,0.25,2.54c0.67,0.4,1.65-0.1,2.19-1.1 C98.46,57.98,98.35,56.85,97.67,56.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.24,61.57l2.24,1.33c-0.2-0.12-0.32-0.36-0.34-0.71c-0.02-0.71,0.44-1.6,1.04-1.97 c0.31-0.19,0.6-0.22,0.8-0.1l-2.24-1.32c-0.21-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.07,1.27-1.03,1.98 C98.92,61.21,99.05,61.46,99.24,61.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M103.32,60.83c-0.03-0.72-0.54-0.99-1.14-0.62c-0.6,0.38-1.06,1.27-1.04,1.97c0.03,0.72,0.54,1,1.14,0.62 C102.89,62.42,103.35,61.54,103.32,60.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M82.84,54.18l11.45,6.76c-0.44-0.27-0.73-0.82-0.75-1.6c-0.08-1.61,0.97-3.61,2.32-4.46 c0.71-0.43,1.35-0.48,1.81-0.2L86.2,47.9c-0.47-0.28-1.13-0.21-1.82,0.23c-1.35,0.83-2.39,2.84-2.32,4.46 C82.1,53.37,82.4,53.92,82.84,54.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M86.78,49.65c-0.07-1.49-1.14-2.07-2.4-1.29c-1.25,0.77-2.21,2.64-2.15,4.13c0.08,1.5,1.15,2.09,2.4,1.3 C85.89,53,86.84,51.14,86.78,49.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M86.59,50.18c-0.05-1.15-0.88-1.59-1.84-0.99c-0.96,0.6-1.7,2.03-1.65,3.16c0.06,1.16,0.88,1.61,1.84,1 C85.9,52.75,86.63,51.32,86.59,50.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M94.61,52.87c-0.45-0.26-1.08-0.22-1.75,0.2c-0.64,0.4-1.21,1.09-1.62,1.85l-5.32-3.11 c0.41-0.78,0.99-1.46,1.63-1.87c0.68-0.43,1.3-0.48,1.76-0.21L94.61,52.87z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M88.51,64.44c1.07,0.6,2.47,0.75,3.48,0.4c-0.35,0.12-0.67,0.12-0.92-0.03c-0.32-0.2-0.53-0.6-0.55-1.16 c-0.06-1.17,0.69-2.61,1.67-3.23c0.5-0.31,0.96-0.35,1.3-0.14c0.25,0.15,0.43,0.43,0.51,0.81c-0.3-1.36-1.29-2.39-2.11-2.91 c-0.48-0.3-1.13-0.25-1.83,0.19c-1.35,0.86-2.39,2.85-2.3,4.46C87.78,63.63,88.07,64.17,88.51,64.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M94,61.09c0.1,0.3,0.48,0.89,0.94,1.2c-0.21-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.06,1.27-1.02,1.98 c0.02,0.34,0.14,0.59,0.33,0.7c-0.09-0.05-0.22-0.1-0.34-0.15c-0.35-0.1-0.78-0.14-1.12-0.08c-0.35,0.12-0.67,0.12-0.92-0.03 c-0.32-0.2-0.53-0.6-0.55-1.16c-0.06-1.17,0.69-2.61,1.67-3.23c0.5-0.31,0.96-0.35,1.3-0.14C93.74,60.43,93.93,60.71,94,61.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M91.87,59.95c-0.67-0.4-1.66,0.1-2.19,1.11c-0.53,1.01-0.42,2.14,0.26,2.54c0.67,0.4,1.65-0.1,2.19-1.1 C92.66,61.48,92.54,60.34,91.87,59.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M93.45,65.07l2.24,1.33c-0.2-0.12-0.33-0.36-0.34-0.71c-0.02-0.71,0.44-1.6,1.03-1.97 c0.31-0.19,0.6-0.22,0.8-0.1l-2.24-1.32c-0.21-0.12-0.49-0.1-0.8,0.09c-0.6,0.38-1.06,1.27-1.02,1.98 C93.13,64.71,93.26,64.96,93.45,65.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M97.52,64.33c-0.03-0.72-0.54-0.99-1.14-0.62c-0.6,0.38-1.06,1.27-1.03,1.97c0.03,0.72,0.54,1,1.14,0.62 C97.09,65.92,97.55,65.03,97.52,64.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M77.06,57.68l11.45,6.76c-0.44-0.27-0.73-0.81-0.76-1.6c-0.08-1.61,0.96-3.61,2.3-4.46 c0.7-0.43,1.34-0.48,1.81-0.2L80.39,51.4c-0.47-0.28-1.13-0.21-1.82,0.23c-1.35,0.83-2.37,2.84-2.3,4.46 C76.32,56.87,76.61,57.42,77.06,57.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M80.98,53.14c-0.07-1.49-1.14-2.07-2.4-1.29c-1.25,0.77-2.2,2.64-2.14,4.13c0.09,1.5,1.15,2.09,2.41,1.3 C80.1,56.5,81.04,54.64,80.98,53.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M80.78,53.68c-0.05-1.15-0.88-1.59-1.84-0.99c-0.96,0.6-1.69,2.03-1.64,3.16c0.06,1.16,0.88,1.61,1.84,1 C80.11,56.25,80.83,54.82,80.78,53.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M88.8,56.37c-0.45-0.26-1.08-0.22-1.75,0.2c-0.64,0.4-1.21,1.09-1.61,1.85l-5.32-3.11 c0.41-0.78,0.98-1.46,1.62-1.87c0.67-0.43,1.29-0.48,1.75-0.21L88.8,56.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.098,
    y1: 55.3998,
    x2: 75.752,
    y2: 52.1789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#454D50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    style: {
      stopColor: "#495155"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    style: {
      stopColor: "#565E61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7174"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "60.65,45.05 63.84,43.12 90.99,59.05 87.8,60.98  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "60.65,45.05 64.64,153.61 90.32,169.51 87.8,60.98  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.3373,
    y1: 148.6588,
    x2: 114.5378,
    y2: 34.3162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8E9395"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CECECE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41494C"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "60.65,45.05 64.64,153.62 90.32,169.51 87.8,60.98  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.3127,
    y1: 182.7477,
    x2: 145.703,
    y2: -2.7744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6F7578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2222,
    style: {
      stopColor: "#73797C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4646,
    style: {
      stopColor: "#808688"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7166,
    style: {
      stopColor: "#969B9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9738,
    style: {
      stopColor: "#B4B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B8BBBC"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "90.99,59.05 93.34,167.57 90.32,169.51 87.8,60.98  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.0637,
    y1: 65.0199,
    x2: 94.5203,
    y2: 36.8662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC1C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3274,
    style: {
      stopColor: "#BABDBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6839,
    style: {
      stopColor: "#ADB0B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B9FA1"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "60.47,40.28 102.52,15.24 129.74,31.17 87.69,56.21  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "60.47,40.28 60.65,45.05 87.8,60.98 87.69,56.21  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.2883,
    y1: 76.7061,
    x2: 133.3883,
    y2: -6.2999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73797C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    style: {
      stopColor: "#777D80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F8587"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "129.74,31.17 129.75,35.94 87.8,60.98 87.69,56.21  "
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M87.69,56.21c3.35-2.28,6.77-4.46,10.21-6.62c3.44-2.16,6.94-4.24,10.42-6.37 c3.53-2.05,7.04-4.14,10.61-6.15c3.57-2.01,7.16-4.01,10.82-5.9c-3.44,2.28-6.92,4.45-10.41,6.61c-3.48,2.16-7,4.24-10.48,6.37 c-3.52,2.05-7.01,4.14-10.54,6.15C94.78,52.32,91.26,54.31,87.69,56.21z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "92.92,176.43 92.95,178.11 91.65,178.95 91.61,177.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "88.55,180.95 92.95,178.11 91.61,177.27 88.51,179.27  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "92.85,173.5 92.89,175.19 91.58,176.03 91.54,174.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "88.48,178.03 92.89,175.19 91.54,174.35 88.44,176.34  "
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "98.47,172.86 98.51,174.54 97.19,175.38 97.16,173.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "94.09,177.38 98.51,174.54 97.16,173.7 94.05,175.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "98.42,169.93 98.45,171.61 97.14,172.46 97.1,170.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "94.03,174.45 98.45,171.61 97.1,170.77 93.99,172.77  "
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "104.05,169.29 104.08,170.97 102.76,171.81 102.74,170.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "99.64,173.81 104.08,170.97 102.74,170.13 99.61,172.12  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "104,166.36 104.03,168.04 102.71,168.89 102.69,167.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "99.59,170.88 104.03,168.04 102.69,167.2 99.56,169.2  "
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "109.65,165.71 109.67,167.4 108.35,168.24 108.33,166.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "105.22,170.24 109.67,167.4 108.33,166.56 105.2,168.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "109.61,162.79 109.63,164.47 108.31,165.31 108.29,163.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "105.18,167.31 109.63,164.47 108.29,163.63 105.15,165.63  "
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "115.27,162.14 115.29,163.83 113.96,164.67 113.94,162.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "110.82,166.66 115.29,163.83 113.94,162.99 110.8,164.98  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "115.24,159.22 115.26,160.9 113.93,161.74 113.91,160.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "110.78,163.74 115.26,160.9 113.91,160.06 110.76,162.06  "
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "120.92,158.57 120.93,160.26 119.6,161.1 119.58,159.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "116.44,163.09 120.93,160.26 119.58,159.42 116.42,161.41  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "120.9,155.65 120.91,157.33 119.58,158.17 119.56,156.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "116.41,160.17 120.91,157.33 119.56,156.49 116.4,158.49  "
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "126.58,155 126.59,156.69 125.25,157.53 125.24,155.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "122.08,159.52 126.59,156.69 125.24,155.85 122.07,157.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "126.57,152.08 126.57,153.76 125.24,154.6 125.23,152.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "122.07,156.6 126.57,153.76 125.23,152.92 122.06,154.92  "
  })))), /*#__PURE__*/React.createElement("g", null, _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "166.81,150.01 133.64,138.67 133.65,41.22 168.54,52.61  "
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "167.08,137.16 133.69,125.81 133.69,123.64 167.12,135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "165.04,120.79 145.21,114.09 133.69,123.64 167.12,135  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M133.69,123.64c2.84,0.81,5.66,1.69,8.47,2.58l8.4,2.76l8.32,2.92c2.76,1,5.51,2.01,8.24,3.1 c-2.81-0.8-5.61-1.69-8.4-2.58l-8.37-2.76l-8.35-2.92C139.23,125.74,136.45,124.73,133.69,123.64z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "167.38,120.34 133.69,108.98 133.69,106.82 167.42,118.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "165.32,103.97 145.31,97.27 133.69,106.82 167.42,118.18  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M133.69,106.82c2.87,0.81,5.71,1.69,8.55,2.58l8.47,2.76l8.4,2.92c2.78,1,5.56,2.01,8.31,3.1 c-2.84-0.81-5.66-1.69-8.48-2.58l-8.44-2.76l-8.42-2.92C139.28,108.92,136.47,107.91,133.69,106.82z"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "167.68,103.53 133.69,92.16 133.69,90 167.72,101.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "165.59,87.16 145.41,80.45 133.69,90 167.72,101.37  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M133.69,90c2.89,0.81,5.76,1.69,8.62,2.58l8.54,2.76l8.47,2.92c2.81,1,5.61,2.01,8.39,3.1 c-2.86-0.81-5.71-1.69-8.55-2.58l-8.52-2.76l-8.49-2.92C139.33,92.1,136.5,91.09,133.69,90z"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "167.98,86.71 133.69,75.34 133.69,73.18 168.02,84.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "165.87,70.34 145.51,63.63 133.69,73.18 168.02,84.56  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M133.69,73.18c2.92,0.81,5.81,1.69,8.7,2.59l8.62,2.77l8.55,2.92c2.83,1,5.66,2.02,8.46,3.1 c-2.89-0.81-5.76-1.69-8.63-2.58l-8.59-2.77l-8.57-2.92C139.38,75.28,136.53,74.27,133.69,73.18z"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "168.28,69.9 133.69,58.52 133.69,56.36 168.32,67.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "166.15,53.52 145.62,46.81 133.69,56.36 168.32,67.74  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M133.69,56.36c2.94,0.81,5.86,1.69,8.77,2.59l8.69,2.77l8.62,2.92c2.86,1,5.71,2.02,8.53,3.11 c-2.91-0.81-5.81-1.69-8.7-2.58l-8.67-2.77l-8.64-2.93C139.43,58.46,136.55,57.45,133.69,56.36z"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "168.58,53.08 133.69,41.7 133.7,39.53 168.61,50.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "167.6,44.32 138.82,35.46 133.7,39.53 168.61,50.93  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M133.7,39.53c2.97,0.81,5.91,1.69,8.85,2.59l8.77,2.77l8.69,2.93c2.88,1,5.76,2.02,8.61,3.11 c-2.94-0.81-5.86-1.69-8.78-2.59l-8.74-2.77l-8.72-2.93C139.48,41.64,136.58,40.62,133.7,39.53z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.1095,
    y1: 47.9067,
    x2: 149.796,
    y2: 40.7274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D8385"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2606,
    style: {
      stopColor: "#82878A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5449,
    style: {
      stopColor: "#8F9496"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#A5A8AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B7B8"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "127.32,35.02 129.71,32.67 172.57,45.86 170.14,48.21  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.8928,
    y1: 147.8335,
    x2: 148.4584,
    y2: 142.8371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#888D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3634,
    style: {
      stopColor: "#83898B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7591,
    style: {
      stopColor: "#767C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7174"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "131.37,138.12 133.64,135.77 164.61,146.56 164.56,149.47  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.5137,
    y1: 148.4657,
    x2: 130.6926,
    y2: 91.6412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73797C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4602,
    style: {
      stopColor: "#777D80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#848A8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    style: {
      stopColor: "#868B8D"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "131.26,40.67 133.65,41.22 133.64,135.77 131.37,138.12  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M127.32,35.02l0.34,108.48l40.48,13.14l2.01-108.42L127.32,35.02z M164.56,149.47l-33.19-11.35 l-0.11-97.45l34.91,11.39L164.56,149.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.4226,
    y1: 171.0122,
    x2: 226.457,
    y2: -18.0002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#777D7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#73797C"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "172.57,45.86 170.43,154.28 168.14,156.63 170.14,48.21  "
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M168.14,156.63c-0.04-9.03,0.03-18.07,0.12-27.1l0.38-27.1l0.61-27.1c0.25-9.03,0.51-18.07,0.9-27.1 c0.05,9.04-0.02,18.07-0.11,27.11l-0.39,27.1l-0.62,27.1C168.77,138.56,168.51,147.59,168.14,156.63z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.2133,
    y1: 31.3789,
    x2: 128.0582,
    y2: 36.7878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9B5B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2085,
    style: {
      stopColor: "#EDECEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4267,
    style: {
      stopColor: "#E9E8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#DCDBD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9112,
    style: {
      stopColor: "#C7C6C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDBCBA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M132.99,33.1l-3.25-1.92l-2.78,2.86c-0.19,0.15-0.31,0.34-0.31,0.55c0,0.52,0.71,0.94,1.59,0.94 c0.5,0,0.95-0.14,1.24-0.35L132.99,33.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.2133,
    y1: 31.3789,
    x2: 128.0582,
    y2: 36.7878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9B5B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2085,
    style: {
      stopColor: "#EDECEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4267,
    style: {
      stopColor: "#E9E8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#DCDBD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9112,
    style: {
      stopColor: "#C7C6C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDBCBA"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M132.99,33.1l-3.25-1.92l-2.78,2.86c-0.19,0.15-0.31,0.34-0.31,0.55c0,0.52,0.71,0.94,1.59,0.94 c0.5,0,0.95-0.14,1.24-0.35L132.99,33.1z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M128.24,33.97c-0.57,0-1.02,0.27-1.02,0.6c0,0.33,0.46,0.6,1.02,0.61c0.57,0,1.02-0.27,1.02-0.6 C129.27,34.25,128.81,33.98,128.24,33.97z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCavesvin);
export default __webpack_public_path__ + "static/media/Caves à vin.d92a75f63e5948d85398d619b991e912.svg";
export { ForwardRef as ReactComponent };